import './dashboard.css';
import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import { Button, Grid, Grid2, Typography, Stack, Pagination, Avatar, FormControl, InputLabel, Select, MenuItem, IconButton, Paper, Snackbar, Modal } from '@mui/material';
import React, { useEffect, useRef, useState,useMemo } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TablePagination } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import prevIcon from '../../assets/icons/left-arrow.svg'
import CloseIcon from '@mui/icons-material/Close';
import nextIcon from '../../assets/icons/right-arrow.svg';
import starIcon from '../../assets/icons/starIcon.png';
import VisibilityIcon from '@mui/icons-material/Visibility';
import defaultImg from '../../assets/images/defaultimg.png';
import { CSVLink } from "react-csv";
import axios from 'axios';
import {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
} from '../commonFunc.jsx';
import { GoogleMap, Marker, InfoWindow } from '@react-google-maps/api';
import { useGoogleMapsLoader } from '../../utils/GoogleMapsLoader';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import mapPin from '../../assets/icons/LocationPin.svg';
import mapPinoffline from '../../assets/icons/LocationPinoffline.svg';
import TokenError from '../tokenError';
import importArrowIcon from '../../assets/images/importArrow.svg';
import config from '../../config/config.js';
import { Dialog, DialogTitle, DialogContent, TextField, Box} from '@mui/material';
import { Label } from 'flowbite-react';
import { styled } from '@mui/material/styles'
import UploadIcon from '@mui/icons-material/Upload'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DatePicker } from '@mui/x-date-pickers';
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import {CustomSwitch }from "../ui/Toggle.jsx";
import pickupMarker from '../../assets/icons/PickupIcon.svg';


dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

const UploadButton = styled(Button)({
  color: '#6B7280',
  backgroundColor: '#fff',
  border: '1px solid #E5E7EB',
  boxShadow: 'none',
  textTransform: 'none',
  padding: '6px 16px',
  borderRadius: '6px',
  fontSize: '14px',
  '&:hover': {
    backgroundColor: '#F9FAFB',
    borderColor: '#E5E7EB',
  },
  '& .MuiButton-startIcon': {
    marginRight: 8,
  },
})
const ImagePreviewBox = styled(Box)({
  width: '80px',
  height: '80px',
  backgroundColor: '#F9FAFB',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid #F3F4F6',
})

const PlaceholderImage = styled('img')({
  width: '40px',
  height: '40px',
  opacity: 0.5,
})

const Dashboard = () => {

    const serverUrl = config.serverUrl;
    const navigate = useNavigate();
    const location = useLocation();

    const [rows, setRows] = useState([]);
    const [allData, setAllData] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [paginatedData, setPaginatedData] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('driver_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [driverId, setDriverId] = useState('');
    const [driverPhone, setDriverPhone] = useState('');
    const [verificationStatus, setVerificationStatus] = useState("");
    const [gpsStatus, setGpsStatus] = useState("");
    const [availableVehicle, setAvailableVehicle] = useState([]);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [openAddModal, setOpenAddModal] = useState(false);
    const [activaDocs, setActivaDocs] = useState([]);
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);

    const [newDriverName, setNewDriverName] = useState('');
    const [newDriverPhone, setNewDriverPhone] = useState('');
    const [newDriverEmail, setNewDriverEmail] = useState('');
    const [newDriverVehicle, setNewDriverVehicle] = useState('');
    const [newDriverDocuments, setNewDriverDocuments] = useState([]);
    const [newDriverDob, setNewDriverDob] = useState(dayjs());
    const [newDriverGender, setNewDriverGender] = useState(1);
    const [uploadedImage, setUploadedImage] = useState(''); 
    const [newDriverCountryCode, setNewDriverCountryCode] = useState('');
    const [openTmsDriver, setOpenTmsDriver] = useState(false);
    const [tmsDriverName, setTmsDriverName] = useState('');
    const [tmsDriverPhone, setTmsDriverPhone] = useState('');
    const [tmsDriverEmail, setTmsDriverEmail] = useState('');
    const [tmsDriverDocImage, setTmsDriverDocImage] = useState('');
    const [tmsDriverDocImageUrl, setTmsDriverDocImageUrl] = useState('');
    const [tmsDriverCountryCode, setTmsDriverCountryCode] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [openDocImage, setOpenDocImage] = useState(false);
    const [currentImage, setCurrentImage] = useState('');
    const [colorCode, setColorCode] = useState('#000000');
    const [activeStatusFilter , setActiveStatusFilter] = useState('');
    const [driverStatuses, setDriverStatuses] = useState({});
    const [txnLoading, setTxnLoading] = useState(false);

    const is_tms_driver = localStorage.getItem('is_tms_driver');
    const admin_set_driver_online_status = localStorage.getItem('admin_set_driver_online_status');
    const driverDataShown = localStorage.getItem('hidedriverinfo');

    const is_rizzo_client = localStorage.getItem('is_rizzo_client');
    const clientDemoType = localStorage.getItem('clientDemoType');
    const is_driver_debt_limit_enabled = localStorage.getItem('is_driver_debt_limit_enabled') || 0;
    const show_driver_gps_status = localStorage.getItem('show_driver_gps_status') || 0;
    let permissions = [];
    const Location = useLocation();
    const latestRequestRef = useRef(0);
    const [findOtpModal, setFindOtpModal] = useState(false);
    const [searchDriverId, setSearchDriverId] = useState("");
    const [searchPhone, setSearchPhone] = useState("");
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [matchedDrivers, setMatchedDrivers] = useState([]);
    const admin_id = localStorage.getItem("admin_id");
    const { isLoaded: isMapsLoaded } = useGoogleMapsLoader();
    const [mapReady, setMapReady] = useState(false);
    const [allDriversMapReady, setAllDriversMapReady] = useState(false);

    const [allDriversMapOpen, setAllDriversMapOpen] = useState(false);
    const [selectedMarkerInfo, setSelectedMarkerInfo] = useState(null);
    const allDriversMapRef = useRef(null);

    const [singleDriverMapOpen, setSingleDriverMapOpen] = useState(false);
    const [selectedMapDriver, setSelectedMapDriver] = useState(null);
    const storedFleetId = localStorage.getItem('fleetId');
    const FleetIdFromLocal = storedFleetId === "0" ? null : storedFleetId;

    const [driverFetched, setDriverFetched] = useState(false);      // gate for the rest of the form
    const [driverByPhone, setDriverByPhone] = useState(null);       // existing driver found by phone
    const [showDriverExistsDialog, setShowDriverExistsDialog] = useState(false);
    const [driverExistsMessage, setDriverExistsMessage] = useState('');
    const fleetFieldsLocked = Boolean(FleetIdFromLocal) && !driverFetched;
    const hideDocuments = Boolean(FleetIdFromLocal) && Boolean(driverByPhone && driverByPhone.driver_id);

    // Center for the "all drivers" map (average of valid coordinates, fallback to city center)
    const allDriversMapCenter = useMemo(() => {
        const validRows = (filteredRows || []).filter(r => {
            const lat = parseFloat(r.current_latitude);
            const lng = parseFloat(r.current_longitude);
            return !isNaN(lat) && !isNaN(lng) && !(lat === 0 && lng === 0);
        });
        console.log('[LiveLocations] valid rows for center calc:', validRows.length, 'of', filteredRows.length);
        if (validRows.length === 0) {
            return { lat: 28.6448, lng: 77.216721 };
        }
        const avgLat = validRows.reduce((sum, r) => sum + parseFloat(r.current_latitude), 0) / validRows.length;
        const avgLng = validRows.reduce((sum, r) => sum + parseFloat(r.current_longitude), 0) / validRows.length;
        return { lat: avgLat, lng: avgLng };
          }, [filteredRows]);

          const searchDriverByPhone = async () => {
  if (!newDriverPhone) {
    setDriverFormErrors(prev => ({ ...prev, phone: 'Phone number is required' }));
    return;
  }
  setDriverFormErrors(prev => ({ ...prev, phone: '' }));

  try {
    const token = localStorage.getItem('token');
    const url = serverUrl + '/driver/driver_by_phone_no';
    const obj = {
      token,
      timestamp: new Date().getTime(),
      phone_number: newDriverPhone,
      fleet_id: FleetIdFromLocal,
    };
    const response = await makeGetRequestToUrl(url, obj);

    if (response.flag == 102) {
      localStorage.removeItem('token');
      setErrorMessage('Your session has expired. Please log in again.');
      setTokenExpired(true);
      setTimeout(() => navigate('/signup'), 2000);
      return;
    }

    if (response.flag === 200) {
      if (response.data && response.data.driver_id === -1) {
        // Driver not found -> let them fill the form from scratch
        setDriverByPhone(null);
        setNewDriverName('');
        setNewDriverEmail('');
        setDriverFetched(true);
        setMessage('Driver not found');
        showSnackbar(true);
      } else {
        // Driver already exists in the system -> prefill and allow attaching
        const d = response.data.driver_details || {};
        setDriverByPhone(d);
        setNewDriverName(d.driver_name || '');
        setNewDriverEmail(d.email || '');
        setDriverFetched(true);
      }
    } else if (response.flag === 415 || response.flag === 416) {
      // Not allowed (e.g. already in another fleet / already added)
      setDriverByPhone(null);
      setDriverFetched(false);
      setDriverExistsMessage(response.message);
      setShowDriverExistsDialog(true);
    } else if (response.flag === 410) {
      // New driver -> let them fill the form from scratch
      setDriverByPhone(null);
      setNewDriverName('');
      setNewDriverEmail('');
      setDriverFetched(true);
    } else {
      setDriverByPhone(null);
      setDriverFetched(false);
      setMessage(response.message || 'Unable to fetch driver details');
      showSnackbar(true);
    }
  } catch (error) {
    console.error('Error fetching driver by phone:', error);
    setMessage('Error fetching driver details');
    showSnackbar(true);
  }
};

const onAllDriversMapLoad = (map) => {
    allDriversMapRef.current = map;

    window.google.maps.event.addListenerOnce(map, 'idle', () => {
        const validPoints = (filteredRows || [])
            .map(row => ({
                lat: parseFloat(row.current_latitude),
                lng: parseFloat(row.current_longitude),
            }))
            .filter(p => !isNaN(p.lat) && !isNaN(p.lng) && !(p.lat === 0 && p.lng === 0));

        console.log('[LiveLocations] idle — valid points:', validPoints.length);

        if (validPoints.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            validPoints.forEach(p => bounds.extend(new window.google.maps.LatLng(p.lat, p.lng)));
            map.fitBounds(bounds);
        }

        setAllDriversMapReady(true);
    });
};


    const handleOpenSingleDriverMap = (row) => {
        console.log('SELECTED DRIVER:', row);
        console.log('LAT:', row.current_latitude);
        console.log('LNG:', row.current_longitude);

        setSelectedMapDriver({
            ...row,
            mapLat: Number(row.current_latitude),
            mapLng: Number(row.current_longitude),
        });

        setSingleDriverMapOpen(true);
    };

    useEffect(() => {
        if (singleDriverMapOpen) {
            setMapReady(false);
        }
    }, [singleDriverMapOpen, selectedMapDriver]);
    useEffect(() => {
        if (allDriversMapOpen) {
            setAllDriversMapReady(false);
        }
    }, [allDriversMapOpen]);


    try {
      const stored = localStorage.getItem('clientTabPermission');
      permissions = stored ? JSON.parse(stored) : [];
      if (!Array.isArray(permissions)) {
        permissions = [];
      }
    } catch (error) {
      console.error("Invalid clientTabPermission in localStorage:", error);
      permissions = [];
    }

    const customerTab = permissions.find(p => p.tab_id === 40);

    // Check if permission "1" exists
        const hasPermission2 = customerTab?.permissions?.split(',').includes("2");
        const hasPermission3 = customerTab?.permissions?.split(',').includes("3");
        const hasPermission4 = customerTab?.permissions?.split(',').includes("4");
    

    // Form validation errors for Add Driver form
    const [driverFormErrors, setDriverFormErrors] = useState({
        name: '',
        phone: '',
        email: '',
    });
    
    // Document validation errors
    const [documentErrors, setDocumentErrors] = useState([]);
    
    // Form validation errors for TMS Driver
    const [tmsDriverErrors, setTmsDriverErrors] = useState({
        name: false,
        email: false,
        phone: false,
        document: false
    });


  const handleToggle = async (driverId, checked) => {
    try {
      const token = localStorage.getItem('token');

      const url = operationsUrl + '/panel/update_driver_online_status';
      const payload = {
        driver_id: driverId,
        status: checked ? 1 : 0 ,
        token
      };
      
      const response = await makePostRequestToUrl(url, payload);
      
      if (response.flag === 200) {
        setDriverStatuses(prev => ({
          ...prev,
          [driverId]: checked
        }));
        
        setMessage(response.message || `Driver status updated successfully`);
        showSnackbar(true);
      } else {
        setMessage(response.message || 'Failed to update driver status');
        showSnackbar(true);
      }
    } catch (error) {
      console.error('Error updating driver status:', error);
      setMessage('Error updating driver status');
      showSnackbar(true);
    }
  };

    const add_driver_enabled_for_panel = localStorage.getItem('add_driver_enabled_for_panel');
    const driver_vehicle_attachment_enabled = localStorage.getItem('driver_vehicle_attachment_enabled');
    const is_tms_add_driver = localStorage.getItem('is_tms_add_driver');
    
    // CSV import-related state
    const fileInputRef = useRef(null);
    const [showTemplateButton, setShowTemplateButton] = useState(false);
    
    const [cityFilter, setCityFilter] = useState(null);
    const [debtLimit, setDebtLimit] = useState(cities[0].driver_debt_limit);
    const handleFilterChange = (filterType, value) => {    //handle the city filter
      if (filterType === 'city'){
        setCityFilter(value);
        const selectedCity = cities.find(city => city.city_id === value);
        if (selectedCity) {
          setDebtLimit(selectedCity.driver_debt_limit);
        }
      } 
    };

    const [open, setOpen] = useState(false);
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('');
    const [type, setType] = useState('credit');

    const handleOpen = (row) => {
      setSelectedRow(row);
      setType('credit'); // Reset to default when opening modal
      setAmount(''); // Clear amount
      setReason(''); // Clear reason
      setOpen(true);
    };
    const handleClose = () => setOpen(false);

    const handleInputChange = (e) => {
        setDriverId(e.target.value);
        setDriverPhone('');
    };
    
    const handlePhoneChange = (e) => {
        setDriverPhone(e.target.value);
        setDriverId('');
    };

    const handleVerificationChange = (value) => {
        setVerificationStatus(value);
    };    
    
    const handleGpsStatusChange = (value) => {
        setGpsStatus(value);
    };

    const handleOtpSearch = () => {
        const digitsOnly = (val) => (val || "").toString().replace(/\D/g, "");
        let matches = [];

        if (searchDriverId.trim()) {
            matches = rows.filter(
                item => item.driver_id.toString() === searchDriverId.trim()
            );
        } else if (searchPhone.trim()) {
            const searchDigits = digitsOnly(searchPhone);
            matches = rows.filter(
                item => digitsOnly(item.phone_number).includes(searchDigits)
            );
        }

        setMatchedDrivers(matches);

        if (matches.length === 1) {
            setSelectedDriver(matches[0]);  
        } else {
            setSelectedDriver(null);
        }
    };

    const handleFindOtp = () => {
        setFindOtpModal(true);
        setSearchDriverId("");
        setSearchPhone("");
        setSelectedDriver(null);
    };

    useEffect(() => {
        if (!searchDriverId && !searchPhone) {
            setMatchedDrivers([]);
            setSelectedDriver(null);
            return;
        }

        const digitsOnly = (val) => (val || "").toString().replace(/\D/g, "");

        const matches = rows.filter(item =>
            searchDriverId
                ? item.driver_id.toString().includes(searchDriverId)
                : digitsOnly(item.phone_number).includes(digitsOnly(searchPhone))
        );

        setMatchedDrivers(matches);
        setSelectedDriver(matches.length === 1 ? matches[0] : null);
    }, [searchDriverId, searchPhone, rows]);

    useEffect(() => {
        const query = new URLSearchParams(location.search);

        const cityIdParam = query.get("city_id");

        if (cityIdParam) {
            setCityFilter(Number(cityIdParam));
        } else {
            setCityFilter(cities[0]?.city_id);
        }

        const driverIdParam = query.get("driver_id");

        if (driverIdParam) {
            setDriverId(driverIdParam);
        }
    }, [location.search]);



    const fetchData = async () => {
       const requestId = ++latestRequestRef.current;
        const query = new URLSearchParams(location.search);
        const driverIdParam = query.get('driver_id');
        if (driverIdParam && !driverId) {
            setDriverId(driverIdParam);
        }

        const driverPhoneParam = query.get('phone_number');
        let decodedPhoneParam;
        if (driverPhoneParam && !driverPhone) {
            decodedPhoneParam = driverPhoneParam.replace(/ /g, '+'); // Decodes + back to +
            setDriverPhone(decodedPhoneParam);
        }
    
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/driver/fetch_all`;
            if (requestId !== latestRequestRef.current) {
                console.log("Ignoring stale response");
                return;
            }
            const obj={
                token: token, timestamp: timestamp
            }
            if(cityFilter) obj['city_id'] = cityFilter;
            const response =  await makeGetRequestToUrl(url, obj);

            // console.log("response", data)

            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag==200){
            // Sort data in descending order by driver_id
            const sortedData = [...response.data].sort((a, b) => {
                return b.driver_id - a.driver_id;
            });
            
            setRows(sortedData);
            setFilteredRows(sortedData);
            
            const formattedData = formatDataForCSV(sortedData);
            setAllData(formattedData);
                // Apply filter if driverId is set from URL or manually
                if (driverIdParam) {
                    setFilteredRows(sortedData.filter((item) => item.driver_id === parseInt(driverIdParam, 10)));
                }
                if (decodedPhoneParam) {
                    setFilteredRows(sortedData.filter((item) => item.phone_number === decodedPhoneParam));
                }
            }
            
        } catch (error) {
            console.error('Error fetching data:', error);
            setRows([]);
            setFilteredRows([]);
            navigate(location.pathname, { replace: true });
        }
    };

    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
    
    useEffect(() => {
        if (!cityFilter) return;
        fetchData();
    }, [cityFilter]);

    // Apply filter when driverId changes
    // useEffect(() => {
    //     if (driverId && rows&&  rows.length > 0) {
    //         // const filteredData = rows.filter((item) => item.driver_id === parseInt(driverId, 10));
    //         const filteredData = rows.filter((item) => 
    //             item.driver_id.toString().includes(driverId) || driverId === ''
    //         );
    //         setFilteredRows(filteredData);
    //         setPage(0); // Reset to the first page after filtering
    //         navigate(`?driver_id=${driverId}`, { replace: true });
    //     }
    //     else if(driverPhone && rows &&rows.length > 0){
    //         const filteredPhoneData = rows.filter((item) => 
    //             // item.phone_number == driverPhone
    //             item.phone_number.toString().includes(driverPhone) || driverPhone === ''
    //         );

    //         rows.forEach((item) => {
    //             console.log(typeof item.phone_number, item.phone_number);
    //         });

    //         setFilteredRows(filteredPhoneData);
    //         setPage(0); // Reset to the first page after filtering
    //         navigate(`?phone_number=${driverPhone}`, { replace: true });
    //     }
    //     else if (verificationStatus !== "" && rows && rows.length > 0) {
    //         // Ensure verificationStatus is cast to a number before comparing
    //         const filteredVerificationData = rows.filter((item) => item.driver_verification_status === Number(verificationStatus));
    //         setFilteredRows(filteredVerificationData);
    //         setPage(0);
    //     }
    //     else if (rows && rows.length > 0) {
    //         setFilteredRows(rows); // Reset to all rows if no driverId/driverPhone is provided
    //         navigate(location.pathname, { replace: true });
    //     }
    // }, [driverId, driverPhone, verificationStatus]);

    useEffect(() => {
    let filtered = Array.isArray(rows) ? [...rows] : [];

    if (driverId) {
        filtered = filtered.filter(item => item.driver_id.toString().includes(driverId));
    }
    if (driverPhone) {
        filtered = filtered.filter(item => item.phone_number?.toString().includes(driverPhone));
    }
    if (activeStatusFilter === "1") {
        filtered = filtered.filter(item => item.deactivation_status == 1 || item.deactivation_status == 0);
    } else if (activeStatusFilter === "2") {
        filtered = filtered.filter(item => item.deactivation_status == 2);
    }
    if (verificationStatus !== "" && verificationStatus !== undefined && verificationStatus !== null) {
        filtered = filtered.filter(item => item.driver_verification_status == verificationStatus);
    }

    setFilteredRows(filtered);
    setPage(0);
}, [rows, driverId, driverPhone, activeStatusFilter, verificationStatus]);



    // UseEffect for filtering based on driverId changes
    // useEffect(() => {
    //     if (rows.length > 0) { // Ensure rows are fetched before filtering
    //         getFilteredData();
    //     }
    // }, [driverId]);

    // const getFilteredData = () => {
    //     if(driverId){
    //         // setFlag(1);
    //         const filteredData = rows.filter((item) => item.driver_id === parseInt(driverId, 10));
    //         setFilteredRows(filteredData);
    //         setPage(0);
    //         navigate(`?driver_id=${driverId}`, { replace: true });
    //     }
    //     // if(docStatus==-1 || docStatus==0 || docStatus==1 || docStatus==2){
    //     //     setFlag(1);
    //     //     const filteredData = rows.filter((item) => item.driver_verification_status === parseInt(docStatus, 10));

    //     //     const paginated = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    
    //     //     setPaginatedData(paginated);
    //     // }
    //     else{
    //         setFilteredRows(rows);
    //         navigate(location.pathname, { replace: true });
    //     }
    // }

    // Paginate filtered data when `filteredRows`, `page`, or `rowsPerPage` changes
    useEffect(() => {
        const paginated = Array.isArray(filteredRows)
            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : [];
        setPaginatedData(paginated);
    }, [filteredRows, page, rowsPerPage]);

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...filteredRows].sort((a, b) => {
        if (a[property] < b[property]) return isAscending ? -1 : 1;
        if (a[property] > b[property]) return isAscending ? 1 : -1;
        return 0;
        });
        // setRows(sortedRows);
        setFilteredRows(sortedRows);
    };

    const viewData = (row) => {
        navigate('/driver-details', { state: { rowData: row, cityFilter: cityFilter } });
        localStorage.setItem('driver_name', row.driver_name);
        localStorage.setItem('driver_email', row.email);
        localStorage.setItem('driver_image', row.driver_image);
        localStorage.setItem('driver_dob', row.date_of_birth);
        localStorage.setItem('driver_id', row.driver_id);
        localStorage.setItem('driver_phone', row.phone_number);
        localStorage.setItem('country_code', row.country_code);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const formatDataForCSV = (data) => {
        return data ? (data.map((item) => {
            // Apply phone number masking based on driverDataShown
            const maskedPhoneNumber = driverDataShown == '0' ? item.phone_number : (() => {
                if (!item.phone_number) return '****';
                const phone = item.phone_number;
                const cleanPhone = phone.replace(/\D/g, '');
                if (cleanPhone.length <= 4) return '****';
                const firstTwo = cleanPhone.substring(0, 2);
                const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                return "+" + firstTwo + maskedMiddle + lastTwo;
            })();

            // Apply email masking based on driverDataShown
            const maskedEmail = driverDataShown == '0' ? item.email : (() => {
                if (!item.email) return '****';
                const email = item.email;
                const atIndex = email.indexOf('@');
                if (atIndex <= 2) return '****' + email.substring(atIndex);
                const firstTwo = email.substring(0, 2);
                const domain = email.substring(atIndex);
                const maskedMiddle = '*'.repeat(atIndex - 2);
                return firstTwo + maskedMiddle + domain;
            })();

            return {
                ...item,
                phone_number: maskedPhoneNumber,
                email: maskedEmail,
                driver_verification_status:
                    item.driver_verification_status === -1
                    ? 'Not Uploaded'
                    : item.driver_verification_status === 0
                    ? 'Pending'
                    : item.driver_verification_status === 1
                    ? 'Approved'
                    : item.driver_verification_status === 2
                    ? 'Rejected'
                    : item.driver_verification_status, // Fallback in case of an unexpected value
            
            driver_current_status:
                item.driver_current_status === 0 ? 'Offline' : 'Online',
            gps_status:
              item.gps_status == 1
                  ? 'Online'
                  : item.gps_status == 0
                  ? 'Offline'
                  : '--',

            gps_updated_time:
                item.gps_updated_time
                    ? `${formatDateTimeWithOffset(item.gps_updated_time)?.time12Hour} On ${
                          formatDateTimeWithOffset(item.gps_updated_time)?.date
                      }`
                    : '--',

            registered_date : item.registered_date?.split('T')[0],

            date_of_birth : item.date_of_birth?.split('T')[0],

            city_id : (clientCities.find(city => city.city_id === item.city_id)) ? (clientCities.find(city => city.city_id === item.city_id)).city_name : '--',
            
            gender : item.gender==1 ? 'Male' : item.gender==2 ? 'Female' : item.gender==3 ? 'Others' : 'Others',

            debt_amount : item.driver_wallet_balance < debtLimit ? debtLimit - item.driver_wallet_balance : 0
        }})) : '';
    };

    // Define custom headers
    const headers = [
        { label: 'Driver ID', key: 'driver_id' },
        { label: 'Driver Name', key: 'driver_name' },
        { label: 'Email', key: 'email' },
        { label: 'Phone Number', key: 'phone_number' },
        { label: 'Driver Doc Verification Status', key: 'driver_verification_status' },
        { label: 'Driver Image', key: 'driver_image' },
        { label: 'Gps Status', key: 'gps_status' },
        { label: 'GPS Updated Time', key: 'gps_updated_time'},
        { label: 'City', key: 'city_id' },
        { label: 'Gender', key: 'gender' },
        { label: 'Current Latitude', key: 'current_latitude' },
        { label: 'Current Longitude', key: 'current_longitude' },
        { label: 'Date Of Birth', key: 'date_of_birth' },
        { label: 'Total Trips', key: 'total_trips' },
        { label: 'Rating', key: 'rating' },
        { label: 'Driver Current Status', key: 'driver_current_status' },
        { label: 'Driver Wallet Balance', key: 'driver_wallet_balance' },
        { label: 'Debt Amount', key: 'debt_amount' },
        { label: 'Registered Date', key: 'registered_date'}
    ];

    const rizzoHeaders = [
      { label: 'Driver ID', key: 'driver_id' },
      { label: 'Driver Name', key: 'driver_name' },
      { label: 'Email', key: 'email' },
      { label: 'Phone Number', key: 'phone_number' },
      { label: 'Driver Doc Verification Status', key: 'driver_verification_status' },
      { label: 'Driver Image', key: 'driver_image' },
      { label: 'City', key: 'city_id' },
      { label: 'Current Latitude', key: 'current_latitude' },
      { label: 'Current Longitude', key: 'current_longitude' },
      { label: 'Total Trips', key: 'total_trips' },
      { label: 'Rating', key: 'rating' },
      { label: 'Driver Current Status', key: 'driver_current_status' },
      { label: 'Registered Date', key: 'registered_date'},
      { label: 'Color Code', key: 'color_code'}
    ]

    const tmsHeaders = [
      { label: 'Driver ID', key: 'driver_id' },
        { label: 'Driver Name', key: 'driver_name' },
        { label: 'Email', key: 'email' },
        { label: 'Phone Number', key: 'phone_number' },
        { label: 'Driver Image', key: 'driver_image' },
        { label: 'City', key: 'city_id' },
        { label: 'Date Of Birth', key: 'date_of_birth' },
        { label: 'Total Trips', key: 'total_trips' },
        { label: 'Driver Document Image', key: 'driver_doc_image' },
        { label: 'Registered Date', key: 'registered_date'}
    ]

    const formatDateTimeWithOffset = (isoString) => {
    if (!isoString) return { date: null, time: null, offset: 0, time12Hour: null };
    
    const date = new Date(isoString);
    const timezoneOffsetMinutes = date.getTimezoneOffset();
    const offsetHours = Math.abs(Math.floor(timezoneOffsetMinutes / 60)).toString().padStart(2, '0');
    const offsetMinutes = Math.abs(timezoneOffsetMinutes % 60).toString().padStart(2, '0');
    const offsetSign = timezoneOffsetMinutes <= 0 ? '+' : '-';
    
    const formattedDate = date.toISOString().split('T')[0];
    const formattedTime = date.toTimeString().split(' ')[0];
    
    // Format time in 12-hour format with AM/PM
    let hours = date.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const time12Hour = `${hours}:${minutes}:${seconds} ${ampm}`;
    
    return {
        date: formattedDate,
        time: formattedTime,
        time12Hour: time12Hour,
        offset: timezoneOffsetMinutes,
        formattedOffset: `UTC${offsetSign}${offsetHours}:${offsetMinutes}`
    };
};

    const handleSubmit = async () => {
      if (!selectedRow) {
          console.log("No user selected for transaction");
          return;
      }
      setTxnLoading(true);
  
      try {
          const token = localStorage.getItem('token');
          // Map 'credit' to 1 and 'debit' to 2
          const txnType = type === "credit" ? 1 : 2;
  
          const params = {
              token,
              txn_type: txnType,
              amount,
              user_id: selectedRow.driver_id,
              user_type: 1, //driver constant
              reason,
              admin_id
          };
  
          const response = await axios.post(`${serverUrl}/admin/wallet_transactions`, params);
            if(response?.data?.flag == 200){
                showSnackbar(true);
                setMessage("Transaction Successfully");
                await fetchData(); // Re-fetch updated data
                handleClose();
            }else{
                showSnackbar(true);
                setMessage("Failed to make transaction");
            }

          // await fetchData(); // Re-fetch updated data
          // handleClose();
      } catch (error) {
          console.error('Error while submitting:', error.message);
      } finally {
          setTxnLoading(false);
      }
    };

    const addNewDriver = () => {
      setOpenAddModal(true);
      fetchAvailableVehicles();
      fetchDocuments();
      setNewDriverCountryCode('');
      setNewDriverDob(dayjs());
      setDriverFetched(false);
      setDriverByPhone(null);
      setNewDriverDocuments([]);
      setNewDriverEmail('');
      setNewDriverVehicle('');
      setColorCode('#000000');
      setNewDriverName('');
      setNewDriverPhone('');
      setDocumentErrors([]);
      setDriverFormErrors({
        name: '',
        phone: '',
        email: ''
      });
    }

    const saveNewDriver = async() => {
      // Reset all error states
      setDriverFormErrors({
        name: '',
        phone: '',
        email: ''
      });
      
      // Reset document errors
      setDocumentErrors([]);

      // Validate required fields
      let isValid = true;
      const newErrors = {
        name: '',
        phone: '',
        email: ''
      };

      // Check name (required)
      if (!newDriverName || newDriverName.trim() === '') {
        newErrors.name = 'Name is required';
        isValid = false;
      }

      // Check phone (required)
      if (!newDriverPhone || newDriverPhone.trim() === '') {
        newErrors.phone = 'Phone number is required';
        isValid = false;
      }

      // Check email format if provided
      if (!newDriverEmail || newDriverEmail.trim() === '') {
        newErrors.email = 'Email is required';
        isValid = false;
      }

      if (newDriverEmail && newDriverEmail.trim() !== '') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(newDriverEmail)) {
          newErrors.email = 'Invalid email format';
          isValid = false;
        }
      }

      // Check required documents if they are not hidden
      const newDocErrors = [];
      
      if (!hideDocuments) {
        activaDocs.forEach((doc, index) => {
          // Initialize error object for this document
          newDocErrors[index] = { documentNumber: '', image: '' };
          
          // Check if this document is required
          if (doc.is_required === 1) {
            // Check if document number is provided
            if (!newDriverDocuments[index]?.document_number || 
                newDriverDocuments[index]?.document_number.trim() === '') {
              newDocErrors[index].documentNumber = 'Document number is required';
              isValid = false;
            }
            
            // Check if image is uploaded
            const hasValidImage = newDriverDocuments[index]?.images?.some(img => img && img.trim() !== '');
            if (!hasValidImage) {
              newDocErrors[index].image = 'Document image is required';
              isValid = false;
            }
          }

          // Check if expiry date is required and not provided
          if (doc.is_doc_expired === 1 && (!newDriverDocuments[index]?.expiry_date || newDriverDocuments[index]?.expiry_date.trim() === '')) {
            newDocErrors[index] = newDocErrors[index] || {};
            newDocErrors[index].expiryDate = 'Expiry date is required';
            isValid = false;
          }
        });
      }
      
      // Set document errors
      setDocumentErrors(newDocErrors);

      // Update error states
      setDriverFormErrors(newErrors);

      // If validation fails, stop the submission
      if (!isValid) {
        return;
      }

      // Proceed with form submission if valid
      const token = localStorage.getItem('token');
      const formattedDriverDocs = hideDocuments ? [] : newDriverDocuments
      .filter(doc => doc.document_number && doc.document_number.trim() !== '')
      .map(doc => ({
        document_id: doc.document_id,
        document_number: doc.document_number,
        expiry_date: doc.expiry_date,
        images: doc.images.join(';;;;')
      }));

      const payload = {
        token: token,
        phone_number: newDriverPhone,
        country_code: newDriverCountryCode,
        name: newDriverName,
        email: newDriverEmail,
        // gender: newDriverGender,
        city_id: cityFilter,
        // date_of_birth: newDriverDob ? newDriverDob.format('YYYY-MM-DD') : null,
        driver_docs: formattedDriverDocs
      };
      
      if(driver_vehicle_attachment_enabled=="1"){
        payload.vehicle_id = newDriverVehicle
      }
      if(is_rizzo_client!=1){
        payload.gender = newDriverGender
      }
      if(is_rizzo_client!=1){
        payload.date_of_birth = newDriverDob ? newDriverDob.format('YYYY-MM-DD') : null
      }

      if(colorCode && is_rizzo_client==1){
        payload.color_code = colorCode
      }
      if(FleetIdFromLocal){
        payload.fleet_id = FleetIdFromLocal;
      }
      
      if (driverByPhone && driverByPhone.driver_id) {
        payload.driver_id = driverByPhone.driver_id;
      }

      try {
        const url = operationsUrl + '/driver/add_new_driver';
        const response = await makePostRequestToUrl(url,payload);
        if (response.flag === 200) {
          setMessage(response.message)
          showSnackbar(true);
          handleCloseModal(); // Close the modal only on success
          fetchData(); // Refresh data
        } else {
          setMessage(response.message)
          showSnackbar(true);
        }
      } catch (error) {
        console.error('Error while adding:', error);
        setMessage('An error occurred while adding the driver');
        showSnackbar(true);
      }
    }

    const handleCloseModal = () => {
      setOpenAddModal(false);
      setDriverFetched(false);
      setDriverByPhone(null);
    }

    const fetchAvailableVehicles = async() => {
      try {
          const token = localStorage.getItem('token');
          const url = serverUrl + '/panel/fetch_available_vehicles';
          const timestamp = new Date().getTime();
          const body = {
              token: token,
              city_id: cityFilter,
              timestamp: timestamp
          };
          const response =  await makeGetRequestToUrl(url, body);
          if(response.flag==200){
              // Filter active vehicles
              const activeVehicles = response.data;
              // console.log('response.data[0] = ', activeVehicles[0].vehicle_type)
              setAvailableVehicle(activeVehicles);
          }
          if(response.flag==102){
              console.log('Token is expired. Please login again')
              localStorage.removeItem('token');
              setErrorMessage('Your session has expired. Please log in again.');
              setTokenExpired(true);

              setTimeout(() => {
                  navigate('/signup');
              }, 2000);
              // navigate('/signup');
          }
      } 
      catch (error) {
          console.log('error', error);
      }
  }

  const fetchDocuments = async() => {
    try {
        const token = localStorage.getItem('token');
        const url = serverUrl + '/driver/get_required_documents';
        const timestamp = new Date().getTime();
        const body = {
            token: token,
            city_id: cityFilter,
            timestamp: timestamp
        };
        const response =  await makeGetRequestToUrl(url, body);
        if(response.flag==200){
            // Filter active vehicles
            const activeDocs = response.data.filter(doc => doc.is_active === 1);
            // console.log('response.data[0] = ', activeVehicles[0].vehicle_type)
            setActivaDocs(activeDocs);
        }
        if(response.flag==102){
            console.log('Token is expired. Please login again')
            localStorage.removeItem('token');
            setErrorMessage('Your session has expired. Please log in again.');
            setTokenExpired(true);

            setTimeout(() => {
                navigate('/signup');
            }, 2000);
            // navigate('/signup');
        }
    } 
    catch (error) {
        console.log('error', error);
    }
  }

  useEffect(() => {
    const initDocs = activaDocs.map(doc => ({
      document_id: doc.document_id,
      document_number: "",
      expiry_date: "",
      images: Array(doc.no_of_images).fill("")  // Ensure each document has an array of empty strings for images
    }));
    setNewDriverDocuments(initDocs);
  }, [activaDocs]);
  

  const handleFileChange = (docIndex, imgIndex) => async (event) => {
    const file = event.target.files[0];
    if (!file) return;
  
    if (!newDriverDocuments[docIndex]) {
      console.error("Invalid docIndex:", docIndex);
      return;
    }
  
    const formData = new FormData();
    formData.append('image', file);
  
    try {
      const response = await axios.post(operationsUrl + '/upload_image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
  
      const s3Url = response.data.url;
  
      setNewDriverDocuments(prevDocs => {
        const updatedDocs = [...prevDocs];
  
        // Double-check if image slot is valid
        // if (!updatedDocs[docIndex].images) {
        //   updatedDocs[docIndex].images = [];
        // }
  
        const updatedImages = [...updatedDocs[docIndex].images];
        updatedImages[imgIndex] = s3Url;
        // updatedDocs[docIndex].images = updatedImages;
        updatedDocs[docIndex] = {
          ...updatedDocs[docIndex],
          images: updatedImages
        };
  
        return updatedDocs;
      });
  
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };
  
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
        return; 
    }
    showSnackbar(false);
    setShowTemplateButton(false);
  };
  
  //import CSV
  const requiredColumns = ['phone_number', 'driver_name', 'email', 'driver_doc_image'];
  
  const alternativeColumns = {
      'phone_number': ['Phone Number', 'phone_number', 'PHONE_NUMBER', 'Phone_Number'],
      'driver_name': ['Driver Name', 'driver_name', 'DRIVER_NAME', 'Driver_Name'],
      'email': ['Email', 'email', 'EMAIL', 'Email'],
      'driver_doc_image': ['Driver Document Image', 'driver_doc_image', 'DRIVER_DOC_IMAGE', 'Driver_Doc_Image']
  };
  
  // Function to download template CSV file
  const downloadCSVTemplate = () => {
      // Use the required columns with example data
      const headers = requiredColumns;
      const exampleRow = ['9876543210', 'John Doe', 'driver@example.com', 'http://example.com/driver-image.jpg'];
      const csvContent = headers.join(',') + '\n' + exampleRow.join(',');
      
      // Create a blob and download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Drivers_Template.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  };
  
  // Generate template data for CSV download
  const generateTemplateData = () => {
      // Create header row using the first alternative column name for each required column
      const headers = requiredColumns.map(col => alternativeColumns[col] ? alternativeColumns[col][0] : col);
      
      // Create an empty row example
      const emptyRow = {};
      requiredColumns.forEach(col => {
          emptyRow[alternativeColumns[col] ? alternativeColumns[col][0] : col] = '';
      });
      
      return [headers.reduce((obj, header, index) => {
          obj[header] = '';
          return obj;
      }, {})];
  };
  
  // Template CSV headers for download
  const templateHeaders = requiredColumns.map(col => ({
      label: alternativeColumns[col] ? alternativeColumns[col][0] : col,
      key: alternativeColumns[col] ? alternativeColumns[col][0] : col
  }));
  
  // Handle CSV import button click
  const handleImportCSV = () => {
      // Trigger the hidden file input
      if (fileInputRef.current) {
          fileInputRef.current.click();
      }
  };
  
  // Handle the actual file selection
  const handleFileSelect = (event) => {
      const file = event.target.files[0];
      if (!file) {
          setMessage('No file selected');
          showSnackbar(true);
          return;
      }

      
      // Use the imported handleImportCSVWithCaseInsensitive function
      handleImportCSVWithCaseInsensitive(
          file,
          // Success callback
          async (data, headers) => {
              try {
                  if (!data || data.length === 0) {
                      setMessage('CSV file contains no data');
                      showSnackbar(true);
                      return;
                  }
                  
                  // Process the import
                  const token = localStorage.getItem('token');
                  const url = operationsUrl + '/transport/add_bulk_drivers';
                  
                  // Map function to convert CSV data to the expected API format
                  const validDrivers = data.filter(item => {
                      // Check if the required fields exist
                      const hasPhoneNumber = item.phone_number || item['Phone Number'];
                      const hasDriverName = item.driver_name || item['Driver Name'];
                      const hasEmail = item.email || item['Email'];
                      
                      return hasPhoneNumber && hasDriverName && hasEmail;
                  }).map(item => ({
                      city_id: cityFilter,
                      phone_number: item.phone_number || item['Phone Number'] || '',
                      driver_name: item.driver_name || item['Driver Name'] || '',
                      email: item.email || item['Email'] || '',
                      driver_doc_image: item.driver_doc_image || item['Driver Document Image'] || '--'
                  }));
                  
                  if (validDrivers.length === 0) {
                      setMessage('No valid driver data found in CSV');
                      showSnackbar(true);
                      event.target.value = '';
                      return;
                  }
                  
                  try {
                      const response = await makePostRequestToUrl(
                          url,
                          { token: token, drivers: validDrivers },
                      );
                      
                      if (response.flag==200) {
                          setMessage(`Successfully imported ${validDrivers.length} drivers`);
                          fetchData(); // Refresh data
                      } else {
                          setMessage(response.message || 'Failed to import drivers');
                      }
                      showSnackbar(true);
                  } catch (error) {
                      console.error('Error importing drivers:', error);
                      setMessage('Error importing drivers. Please try again.');
                      showSnackbar(true);
                  }
                  
                  // Reset file input
                  event.target.value = '';
              } catch (error) {
                  console.error('Error processing imported data:', error);
                  setMessage('Error processing imported data');
                  showSnackbar(true);
                  event.target.value = '';
              }
          },
          // Error callback
          (error) => {
              console.error('CSV import error:', error);
              let errorMessage = 'Error importing CSV file';
              
              // If we have specific missing columns info
              if (error.missingColumns) {
                  errorMessage = `CSV is missing required columns: ${error.missingColumns.join(', ')}`;
                  // Show template download button in snackbar
                  setShowTemplateButton(true);
              } else if (typeof error === 'string') {
                  errorMessage = error;
                  setShowTemplateButton(false);
              } else if (error.message) {
                  errorMessage = error.message;
                  setShowTemplateButton(false);
              }
              
              setMessage(errorMessage);
              showSnackbar(true);
              event.target.value = '';
          },
          requiredColumns,
          alternativeColumns
      );
  };

const [openRemoveFleetModal, setOpenRemoveFleetModal] = useState(false);
const [driverToRemove, setDriverToRemove] = useState(null);

const handleOpenRemoveFleetModal = (row) => {
  setDriverToRemove(row);
  setOpenRemoveFleetModal(true);
};

const handleCloseRemoveFleetModal = () => {
  setOpenRemoveFleetModal(false);
  setDriverToRemove(null);
};

const handleConfirmRemoveFleet = async () => {
  if (!driverToRemove || !FleetIdFromLocal) return;
  const token = localStorage.getItem('token');
  const url = operationsUrl + '/panel/remove_driver_from_fleet';
  const payload = {
    token,
    driver_id: driverToRemove.driver_id
  };
  try {
    const response = await makePostRequestToUrl(url, payload);
    if (response.flag === 200) {
      setMessage(response.message);
      showSnackbar(true);
      fetchData(); 
    } else {
      setMessage(response.message);
      showSnackbar(true);
    }
  } catch(e) {
    console.error('Error removing from fleet:', e);
    setMessage('Failed to remove driver from fleet');
    showSnackbar(true);
  }
  handleCloseRemoveFleetModal();
};

const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
const [deactivateReason, setDeactivateReason] = useState('');
const [actionType, setActionType] = useState('');  // 'deactivate' or 'delete'
const [driverToAction, setDriverToAction] = useState(null);
const [reasonError, setReasonError] = useState(false);

const handleOpenDeactivateModal = (row, type) => {
  setDriverToAction(row);
  setActionType(type);
  setDeactivateReason('');
  setReasonError(false);
  setOpenDeactivateModal(true);
};

const handleCloseDeactivateModal = () => {
  setOpenDeactivateModal(false);
  setDriverToAction(null);
  setDeactivateReason('');
  setReasonError(false);
};

const handleReasonChange = (e) => {
  setDeactivateReason(e.target.value);
  if (e.target.value.trim() !== '') {
    setReasonError(false);
  }
};

const handleConfirmDeactivate = () => {
  if (deactivateReason.trim() === '') {
    setReasonError(true);
    return;
  }
  
  // Map action types to their corresponding status codes
  let status;
  switch(actionType) {
    case 'activate':
      status = 1; // Activate status code
      break;
    case 'deactivate':
      status = 2; // Deactivate status code
      break;
    case 'delete':
      status = 3; // Delete status code
      break;
    default:
      status = 0;
  }
  
  // Call the existing deleteDeactivate function with the selected driver and status
  deleteDeactivate(driverToAction, status);
  handleCloseDeactivateModal();
  fetchData(); // Refresh data after action
};

const deleteDeactivate = async(row, status) => {
  const token = localStorage.getItem('token');
  const payload = {
    token: token,
    driver_id: row.driver_id,
    status: status,
    reason: deactivateReason // Use the reason from the modal input
  };
  
  try {
    const url = operationsUrl + '/panel/deactivate_driver';
    const response = await makePostRequestToUrl(url, payload);
    if (response.flag === 200) {
        setMessage(response.message)
        showSnackbar(true);
    } else {
        setMessage(response.message)
        showSnackbar(true);
    }
  } catch (error) {
    console.error('Error while deactivating:', error);
    setMessage(error);
  }
  
  fetchData(); // Refresh data to show updated status
}

const addNewTmsDriver = () => {
    // setOpen(true);
    setOpenTmsDriver(true);
    setTmsDriverCountryCode('');
    setTmsDriverName('');
    setTmsDriverEmail('');
    setTmsDriverPhone('');
    setTmsDriverDocImageUrl('');
    setTmsDriverErrors({
      name: false,
      email: false,
      phone: false,
      document: false
    });
}

const handleCloseTmsDriverModal = () => {
    setOpenTmsDriver(false);
    setTmsDriverCountryCode('');
    setTmsDriverName('');
    setTmsDriverEmail('');
    setTmsDriverPhone('');
    setTmsDriverDocImageUrl('');
    setTmsDriverErrors({
      name: false,
      email: false,
      phone: false,
      document: false
    });
}

// useEffect(() => {
//   let filtered = rows;

//   // Filter by activation status
//   if (activeStatusFilter === "1") {
//       filtered = filtered.filter(item =>
//           item.deactivation_status == 1 || item.deactivation_status == 0
//       );
//   } else if (activeStatusFilter === "2") {
//       filtered = filtered.filter(item =>
//           item.deactivation_status == 2
//       );
//   }
//   // "All" shows everyone (no filter)

//   // Filter by verification status
//   if (verificationStatus !== "" && verificationStatus !== undefined && verificationStatus !== null) {
//       filtered = filtered.filter(item =>
//           item.driver_verification_status == verificationStatus
//       );
//   }

//   setFilteredRows(filtered);
//   setPage(0);
// }, [activeStatusFilter, verificationStatus, rows]);

    const handleHealthCardImageChange = async(e) => {
        const file = e.target.files[0];
        if (file) {
            // setHealthCardImageUrl(URL.createObjectURL(file));
            const formData = new FormData();
            formData.append('image', file);
    
            try {
                const response = await axios.post(operationsUrl + '/upload_image', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
    
                const s3Url = response.data.url;
                const newImage = {
                    name: file.name,
                    src: s3Url,
                    isUploaded: true,
                };
                setTmsDriverDocImageUrl(s3Url);
                setTmsDriverDocImage(file);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };

    // Email validation functions
    const validateEmail = (value) => {
        const re = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@\"]+\.)+[^<>()[\]\\.,;:\s@\"]{2,})$/i;
        return re.test(String(value).toLowerCase());
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setTmsDriverEmail(value);
        setEmailError(value.length > 0 && !validateEmail(value));
    };

    const saveNewTmsDriver = async() => {
      // Validate all required fields before submission
      const errors = {
        name: !tmsDriverName.trim(),
        email: !tmsDriverEmail.trim() || emailError,
        phone: !tmsDriverPhone.trim(),
        document: !tmsDriverDocImageUrl
      };
      
      setTmsDriverErrors(errors);
      
      // Check if any errors exist
      if (Object.values(errors).some(error => error)) {
        setMessage('Please fill all the required fields correctly');
        showSnackbar(true);
        return;
      }
      
      const token = localStorage.getItem('token');
      
      const payload = {
        token: token,
        city_id: cityFilter,
        phone_number: tmsDriverPhone,
        country_code: tmsDriverCountryCode,
        name: tmsDriverName,
        email: tmsDriverEmail,
        driver_doc_image: tmsDriverDocImageUrl
      };

      try {
        const url = operationsUrl + '/driver/add_new_driver';
        const response = await makePostRequestToUrl(url, payload);
        
        if (response.flag === 200) {
          setMessage(response.message);
          showSnackbar(true);
          setOpenTmsDriver(false); // Close the modal after saving
          fetchData();
        } else {
          setMessage(response.message);
          showSnackbar(true);
        }
      } catch (error) {
        console.error('Error while adding driver:', error);
        setMessage(typeof error === 'string' ? error : 'Error adding driver');
        showSnackbar(true);
      }
    }

    const handleImageOpen = (image) => {
      setCurrentImage(image);
      setOpenDocImage(true);
    };

    const handleImageClose = () => {
      setOpenDocImage(false);
      setCurrentImage(null);
    };

    return (
      <div>
        {tokenExpired && <TokenError />}

        <Typography style={{ fontSize: "28px", fontWeight: "500" }}>
          User
        </Typography>
        <Typography style={{ color: "#83888E" }}>User / Driver</Typography>

        <Grid2 container spacing={2} direction="row" alignItems="center" wrap="nowrap"
          style={{ marginTop: "2%", marginBottom: "2%" }}
        >
          <Grid2>
            <Select value={cityFilter} onChange={(e) => handleFilterChange('city', e.target.value)} displayEmpty
              style={{
                  width: '200px',height: '46px',borderRadius: '8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
              }}
            >
              <MenuItem value="">All</MenuItem>
              {cities.map((city) => (
                  <MenuItem key={city.city_id} value={city.city_id}>
                      {city.city_name}
                  </MenuItem>
              ))}
            </Select>
        </Grid2>
          <Grid2 xs="auto">
            <input type="number" placeholder="Driver Id" className="filterBtn" value={driverId} onChange={handleInputChange} min="0" 
              onKeyDown={(e) => {
                if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                  e.preventDefault();
                }
              }}
            />
          </Grid2>
          <Grid2 xs="auto">
            <input type="number" placeholder="Phone Number" className="filterBtn"value={driverPhone} onChange={handlePhoneChange} />
          </Grid2>
          {/* Verification Status Dropdown */}
          <Grid2 item>
            <Select value={verificationStatus} onChange={(e) => handleVerificationChange(e.target.value)} displayEmpty
              sx={{
                width: "180px",height: "45px",borderRadius: "8px",backgroundColor: verificationStatus ? "#F9F9F9" : "#FFFFFF",
                color: "#83888E",fontSize: "14px",fontWeight: "500",padding: "10px",
                "& .MuiSelect-select": {paddingLeft: "10px",paddingTop: "10px",paddingBottom: "10px"},
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D1D5DB", // Light grey border
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#B0BEC5",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1976D2", // Blue border when focused
                },
                "&.Mui-focused .MuiSelect-icon": {
                  color: "#1976D2", // Blue icon when focused
                },
              }}
            >
              <MenuItem value={""}>Verification Status</MenuItem>{" "}
              <MenuItem value={-1}>Not Uploaded</MenuItem>
              <MenuItem value={0}>Pending</MenuItem>
              <MenuItem value={1}>Approved</MenuItem>
              <MenuItem value={2}>Rejected</MenuItem>
              <MenuItem value={3}>Expired</MenuItem>
              <MenuItem value={4}>Expiring Soon</MenuItem>
            </Select>
          </Grid2>
          {show_driver_gps_status == 1 && <Grid2 item>
            <Select value={gpsStatus} onChange={(e) => handleGpsStatusChange(e.target.value)} displayEmpty
              sx={{
                width: "180px",height: "45px",borderRadius: "8px",backgroundColor: verificationStatus ? "#F9F9F9" : "#FFFFFF",
                color: "#83888E",fontSize: "14px",fontWeight: "500",padding: "10px",
                "& .MuiSelect-select": {paddingLeft: "10px",paddingTop: "10px",paddingBottom: "10px"},
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#D1D5DB", // Light grey border
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#B0BEC5",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1976D2", // Blue border when focused
                },
                "&.Mui-focused .MuiSelect-icon": {
                  color: "#1976D2", // Blue icon when focused
                },
              }}
            >
              <MenuItem value={""}>GPS Status</MenuItem>{" "}
              <MenuItem value={0}>Offline</MenuItem>
              <MenuItem value={1}>Online</MenuItem>
            </Select>
          </Grid2>}
          <Grid2 item>
                <Select value={activeStatusFilter} 
                onChange={(e) => setActiveStatusFilter(e.target.value)} displayEmpty
                style={{width: '140px',height:'46px',borderRadius:'8px',backgroundColor: activeStatusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="1">Activated</MenuItem>
                    <MenuItem value="2">Deactivated</MenuItem>
                </Select>
            </Grid2>


          {((add_driver_enabled_for_panel == 1 || FleetIdFromLocal) && hasPermission3) && (
            <Grid2 xs="auto">
              <Button variant='contained' style={{width: "124px",height: "44px",backgroundColor: "#000000",textTransform: "none",borderRadius: "8px"}}
              onClick={addNewDriver}>
                  Add Driver
                </Button>
              </Grid2>
            )}

            {is_tms_add_driver==1 && hasPermission3 && (
            <Grid2 xs="auto">
              <Button variant='contained' style={{width: "124px",height: "44px",backgroundColor: "#000000",textTransform: "none",borderRadius: "8px"}}
              onClick={addNewTmsDriver}>
                  Add Driver
                </Button>
              </Grid2>
            )}
            
        </Grid2>

        <Grid2 sx={{display:'flex', marginBottom: "2%"}}>
          <Grid2 xs="auto">
            <Button variant="contained"
              style={{
                width: "120px",height: "44px",backgroundColor: "#36C68F",textTransform: "none",borderRadius: "8px", marginRight: "8px"
              }}
            >
              <CSVLink data={allData}
                headers={is_tms_driver==1 ? tmsHeaders : is_rizzo_client==1 ? rizzoHeaders : headers}
                filename={"Driver Data.csv"}
                style={{ textDecoration: "none" }} // Add this line to remove underline
              >
                <Typography sx={{ color: "#fff" }}>Export CSV</Typography>
              </CSVLink>
            </Button>
          </Grid2>

          <Grid2 xs="auto" container spacing={1} alignItems="center">
            {!FleetIdFromLocal && (
              <>
                <Grid2 item>
                  <Button 
                    variant='outlined' 
                    onClick={downloadCSVTemplate}
                    style={{height: "44px", borderColor: "#000", color: "#000", textTransform: "none", borderRadius: "8px", backgroundColor: "#fff"}}
                  >
                    Sample CSV
                  </Button>
                </Grid2>
                <Grid2 item>
                    <Button 
                      variant='outlined' 
                      onClick={handleImportCSV}
                      style={{height: "44px", borderColor: "#000", color: "#000", textTransform: "none", borderRadius: "8px", backgroundColor: "#fff"}}
                    >
                      Import CSV
                    </Button>
                </Grid2>
              </>
            )}
            <Grid2 item>
                <Button 
                  variant='outlined' 
                  onClick={handleFindOtp}
                  style={{height: "44px", borderColor: "#ffcc77ff", color: "#ffcc77ff", textTransform: "none", borderRadius: "8px", backgroundColor: "#fff"}}
                >
                  Find Otp
                </Button>
                
            </Grid2>
            <Grid2 item>
                <Button 
                  variant='outlined' 
                  onClick={() => setAllDriversMapOpen(true)}
                  startIcon={<LocationOnIcon />}
                  style={{height: "44px", borderColor: "#0065FF", color: "#0065FF", textTransform: "none", borderRadius: "8px", backgroundColor: "#fff"}}
                >
                  Live Locations
                </Button>
            </Grid2>

            
          </Grid2>
        </Grid2>

        <TableContainer className="table-container" style={{ maxHeight: '60vh' }}>
          <Table stickyHeader className="scrollable-table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className="table-header">
                  <TableSortLabel
                    className="table-header"
                    active={orderBy === "driver_id"}
                    direction={orderBy === "driver_id" ? order : "asc"}
                    onClick={() => handleRequestSort("driver_id")}
                    sx={{
                      "& .MuiTableSortLabel-icon": {
                        color: "#0065FF !important", // Change the arrow color
                      },
                    }}
                  >
                    Driver ID
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel
                      className="table-header"
                      active={orderBy === "driver_name"}
                      direction={orderBy === "driver_name" ? order : "asc"}
                      onClick={() => handleRequestSort("driver_name")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "#0065FF !important", // Change the arrow color
                        },
                      }}
                    >
                      Driver
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center" className="table-header">
                  <TableSortLabel
                      className="table-header"
                      active={orderBy === "email"}
                      direction={orderBy === "email" ? order : "asc"}
                      onClick={() => handleRequestSort("email")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "#0065FF !important", // Change the arrow color
                        },
                      }}
                    >
                      Email
                  </TableSortLabel>
                </TableCell>
                {show_driver_gps_status==1 && 
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    {" "}
                    Driver GPS
                  </TableSortLabel>
                </TableCell>
                }
                {show_driver_gps_status==1 && 
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    {" "}
                    Last Gps Update
                  </TableSortLabel>
                </TableCell>
                }
                {is_tms_driver==1 &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel className="table-header">
                      {" "}
                      Driver Document
                    </TableSortLabel>
                  </TableCell>
                }
                {(is_tms_driver!=1 && is_rizzo_client!=1) &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel
                      className="table-header"
                      active={orderBy === "gender"}
                      direction={orderBy === "gender" ? order : "asc"}
                      onClick={() => handleRequestSort("gender")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "#0065FF !important", // Change the arrow color
                        },
                      }}
                    >
                      Gender
                    </TableSortLabel>
                  </TableCell>
                }
                {is_tms_driver!=1 &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel
                      className="table-header"
                      active={orderBy === "current_latitude"}
                      direction={orderBy === "current_latitude" ? order : "asc"}
                      onClick={() => handleRequestSort("current_latitude")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "#0065FF !important", // Change the arrow color
                        },
                      }}
                    >
                      Current Latitude
                    </TableSortLabel>
                  </TableCell>
                }
                {is_tms_driver!=1 &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel
                      className="table-header"
                      active={orderBy === "current_longitude"}
                      direction={orderBy === "current_longitude" ? order : "asc"}
                      onClick={() => handleRequestSort("current_longitude")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "#0065FF !important", // Change the arrow color
                        },
                      }}
                    >
                      Current Longitude
                    </TableSortLabel>
                  </TableCell>
                }
                <TableCell align="center" className="table-header">
                  <TableSortLabel
                    className="table-header"
                    active={orderBy === "total_trips"}
                    direction={orderBy === "total_trips" ? order : "asc"}
                    onClick={() => handleRequestSort("total_trips")}
                    sx={{
                      "& .MuiTableSortLabel-icon": {
                        color: "#0065FF !important", // Change the arrow color
                      },
                    }}
                  >
                    Total Trips
                  </TableSortLabel>
                </TableCell>
                {(is_tms_driver!=1 && clientDemoType!=2) &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel
                      className="table-header"
                      active={orderBy === "rating"}
                      direction={orderBy === "rating" ? order : "asc"}
                      onClick={() => handleRequestSort("rating")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "#0065FF !important", // Change the arrow color
                        },
                      }}
                    >
                      Rating
                    </TableSortLabel>
                  </TableCell>
                }
                {(is_tms_driver!=1 && clientDemoType!=2) &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel
                      className="table-header"
                      active={orderBy === "driver_current_status"}
                      direction={orderBy === "driver_current_status" ? order : "asc"}
                      onClick={() => handleRequestSort("driver_current_status")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "#0065FF !important", // Change the arrow color
                        },
                      }}
                    >
                      Status
                    </TableSortLabel>
                  </TableCell>
                }
                {is_tms_driver!=1 &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel
                      className="table-header"
                      active={orderBy === "driver_verification_status"}
                      direction={orderBy === "driver_verification_status" ? order : "asc"}
                      onClick={() => handleRequestSort("driver_verification_status")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "#0065FF !important", // Change the arrow color
                        },
                      }}
                    >
                      Document Veification Status
                    </TableSortLabel>
                  </TableCell>
                }
                {is_tms_driver!=1 &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel
                      className="table-header"
                      active={orderBy === "driver_wallet_balance"}
                      direction={orderBy === "driver_wallet_balance" ? order : "asc"}
                      onClick={() => handleRequestSort("driver_wallet_balance")}
                      sx={{
                        "& .MuiTableSortLabel-icon": {
                          color: "#0065FF !important", // Change the arrow color
                        },
                      }}
                    >
                      Driver Wallet Balance
                    </TableSortLabel>
                  </TableCell>
                }
                {is_driver_debt_limit_enabled == 1 &&
                  <TableCell align="center" className="table-header">
                    Debt Amount
                  </TableCell>
                }
                {(is_tms_driver!=1 && clientDemoType!=2 && is_rizzo_client==1) &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel className="table-header">
                      Color Code
                    </TableSortLabel>
                  </TableCell>
                }
                <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    OTP
                  </TableSortLabel>
                </TableCell>
                {is_tms_driver!=1 &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel className="table-header">
                      Live Location
                    </TableSortLabel>
                  </TableCell>
                }
                {is_tms_driver!=1 &&
                  <TableCell align="center" className="table-header">
                    <TableSortLabel className="table-header">
                      Action
                    </TableSortLabel>
                  </TableCell>
                }
                {!FleetIdFromLocal && hasPermission2 && <TableCell align="center" className="table-header">
                  <TableSortLabel className="table-header">
                    Deactivate / Delete
                  </TableSortLabel>
                </TableCell>}
                {Boolean(FleetIdFromLocal) && (
                  <TableCell align="center" className="table-header">
                    <TableSortLabel className="table-header">
                      Fleet Action
                    </TableSortLabel>
                  </TableCell>
                )}
                {admin_set_driver_online_status==1 && <TableCell align="center" className="table-header">
                    Driver Status
                </TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "center",
                        width: "auto",
                        minWidth: "100px",
                        pr: "28px",
                      }}
                    >
                      {row.driver_id}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                      <Grid2>
                        <Avatar
                          sx={{ borderColor: "#0065FF", border: 1 }}
                          alt={row.driver_name}
                          src={row.driver_image}
                        ></Avatar>
                      </Grid2>
                      <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                        <Grid2>
                          <Typography>{row.driver_name}</Typography>
                        </Grid2>
                        <Grid2>
                          <Typography
                            sx={{ color: "#83888E", fontSize: "12px" }}
                          >
                            {driverDataShown == 0 ? row.phone_number : (() => {
                                if (!row.phone_number) return '****';
                                const phone = row.phone_number;
                                const cleanPhone = phone.replace(/\D/g, '');
                                if (cleanPhone.length <= 4) return '****';
                                const firstTwo = cleanPhone.substring(0, 2);
                                const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                return "+" + firstTwo + maskedMiddle + lastTwo;
                            })()}
                          </Typography>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ textAlign: "left" }}>
                      {driverDataShown == 0 ? row.email : (() => {
                          if (!row.email) return '****';
                          const email = row.email;
                          const atIndex = email.indexOf('@');
                          if (atIndex <= 2) return '****' + email.substring(atIndex);
                          const firstTwo = email.substring(0, 2);
                          const domain = email.substring(atIndex);
                          const maskedMiddle = '*'.repeat(atIndex - 2);
                          return firstTwo + maskedMiddle + domain;
                      })()}
                    </Typography>
                  </TableCell>
                  {
                    show_driver_gps_status==1 && 
                    <TableCell>
                      <Typography sx={{ textAlign: "left" }}>
                        {row?.gps_status == 1 && (
                            <Typography sx={{color:'#28ce49ff', fontSize:'14px'}}>Online</Typography>
                        )}
                        {row?.gps_status == 0 && (
                            <Typography sx={{color:'#fc4949ff', fontSize:'14px'}}>Offline</Typography>
                        )}                      
                      </Typography>
                    </TableCell>
                  }
                  {
                    show_driver_gps_status==1 && 
                    <TableCell>
                      <Typography sx={{ textAlign: "center",whiteSpace:'nowrap' }}>
                        {
                          row?.gps_updated_time ? (
                                <>
                                {formatDateTimeWithOffset(row.gps_updated_time)?.time12Hour}{" "}
                                On{" "}
                                {formatDateTimeWithOffset(row.gps_updated_time)?.date}
                                </>
                            ) : (
                                "--"
                            )
                            }
                      </Typography>
                    </TableCell>
                  }
                  {is_tms_driver==1 &&
                    <TableCell>
                      {row.driver_doc_image=='' && '--'}
                      {row.driver_doc_image!='' &&
                        <VisibilityIcon sx={{
                          cursor: 'pointer',marginTop: '8px',
                          color: '#0065FF',fontSize: '24px'
                          }} 
                          onClick={() => handleImageOpen(row.driver_doc_image)}
                        />
                      }

                      {/* Modal for Image */}
                      
                    </TableCell>
                  }
                  
                  {(is_tms_driver!=1 && is_rizzo_client!=1) &&
                    <TableCell>
                      <Typography
                        sx={{
                          textAlign: "left",
                          width: "auto",
                          minWidth: "120px",
                        }}
                      >
                        {row.gender == 1
                          ? "Male"
                          : row.gender == 2
                          ? "Female"
                          : row.gender == 3
                          ? "Others"
                          : "Others"}
                      </Typography>
                    </TableCell>
                  }
                  {is_tms_driver!=1 &&
                    <TableCell>
                      <Typography
                        sx={{
                          textAlign: "left",
                          width: "auto",
                          minWidth: "100px",
                        }}
                      >
                        {row.current_latitude}
                      </Typography>
                    </TableCell>
                  }
                  {is_tms_driver!=1 &&
                    <TableCell>
                      <Typography
                        sx={{
                          textAlign: "left",
                          width: "auto",
                          minWidth: "100px",
                        }}
                      >
                        {row.current_longitude}
                      </Typography>
                    </TableCell>
                  }
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "center",
                        width: "auto",
                        minWidth: "100px",
                        marginRight: "12px",
                      }}
                    >
                      {row.total_trips}
                    </Typography>
                  </TableCell>
                  {(is_tms_driver!=1 && clientDemoType!=2) &&
                    <TableCell sx={{ textAlign: "left" }}>
                      <img
                        src={starIcon}
                        height="12px"
                        width="12px"
                        style={{ marginRight: "1%" }}
                      />{" "}
                      {parseFloat(row.rating).toFixed(2)}
                    </TableCell>
                  }
                  {(is_tms_driver!=1 && clientDemoType!=2) &&
                    <TableCell>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor:
                            row.driver_current_status == 0
                              ? "#F9E9E9"
                              : "#E7F8F2",
                          color:
                            row.driver_current_status == 0
                              ? "#D14545"
                              : "#0DBA78",
                          textTransform: "none",
                          pointerEvents: "none",
                          borderRadius: "6px",
                          minWidth: "60px",
                          border: "none",
                          boxShadow: "none",
                          fontFamily: "Poppins",
                          marginRight: "16px",
                        }}
                      >
                        <FiberManualRecordIcon style={{ fontSize: "16px" }} />{" "}
                        {row.driver_current_status == 0 ? "Offline" : "Online"}
                      </Button>
                    </TableCell>
                  }
                  {is_tms_driver!=1 &&
                    <TableCell>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor:
                            row.driver_verification_status == -1
                              ? "#F9F9F9"
                              : row.driver_verification_status == 0 || row.driver_verification_status == 4
                              ? "#F5BB19"
                              : row.driver_verification_status == 1
                              ? "#0DBA78"
                              : "#D14545",
                          color:
                            row.driver_verification_status == -1
                              ? "#000"
                              : "#FFFFFF",
                          textTransform: "none",
                          pointerEvents: "none",
                          borderRadius: "6px",
                          minWidth: "60px",
                          border: "none",
                          boxShadow: "none",
                          fontFamily: "Poppins",
                          width: "auto", // Or set a specific width
                          minWidth: "120px",
                        }}
                      >
                        {row.driver_verification_status == -1
                          ? "Not Uploaded"
                          : row.driver_verification_status == 0
                          ? "Pending"
                          : row.driver_verification_status == 1
                          ? "Approved"
                          : row.driver_verification_status == 2
                          ? "Rejected"
                          : row.driver_verification_status == 3
                          ? "Expired"
                          : row.driver_verification_status == 4
                          ? "Expiring Soon"
                          : ""
                        }
                      </Button>
                    </TableCell>
                  }
                  {is_tms_driver!=1 &&
                    <TableCell>
                      <Typography
                        sx={{
                          textAlign: "center",
                          width: "auto",
                          minWidth: "100px",
                          marginRight: "12px",
                          color: (is_driver_debt_limit_enabled == 1 && row.driver_wallet_balance < debtLimit) ? 'red' : '#000000'
                        }}
                      >
                        {Number(row.driver_wallet_balance || 0).toFixed(2)}
                      </Typography>
                    </TableCell>
                  }
                  {is_driver_debt_limit_enabled == 1 &&
                    <TableCell>
                      <Typography
                        sx={{
                          textAlign: "center",
                          width: "auto",
                          minWidth: "100px",
                          marginRight: "12px",
                          color: row.driver_wallet_balance < debtLimit ? 'red' : '#000000'
                        }}
                      >
                        {row.driver_wallet_balance < debtLimit ? debtLimit - row.driver_wallet_balance : 0}
                      </Typography>
                    </TableCell>
                  }
                  {(is_tms_driver!=1 && clientDemoType!=2 && is_rizzo_client==1) &&
                    <TableCell>
                      <Typography
                        sx={{textAlign: "center",width: "auto",minWidth: "100px",marginRight: "12px"}}
                      >
                        {row.color_code}
                      </Typography>
                    </TableCell>
                  }
                  <TableCell>
                    <Typography
                      sx={{textAlign: "center",width: "auto",minWidth: "100px",marginRight: "12px"}}
                    >
                      {row.login_otp ? row.login_otp : '--'}
                    </Typography>
                  </TableCell>
                  {is_tms_driver!=1 &&
                    <TableCell align="center">
                      <IconButton
                        onClick={() => handleOpenSingleDriverMap(row)}
                        disabled={
                            !Number.isFinite(Number(row.current_latitude)) ||
                            !Number.isFinite(Number(row.current_longitude))
                        }
                        sx={{
                            color:
                                row.driver_current_status == 1
                                    ? '#0DBA78'
                                    : '#D14545',
                        }}
                        title="View driver location"
                    >
                        <LocationOnIcon />
                    </IconButton>
                    </TableCell>
                  }
                  {is_tms_driver!=1 &&
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        onClick={() => viewData(row)}
                        sx={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid black",
                          textTransform: "none",
                          borderRadius: "8px",
                          width: "auto", // Or set a specific width
                          minWidth: "120px",
                          marginBottom: "10px",
                          "&:hover": {
                            backgroundColor: "black",
                            color: "white",
                          },
                          "&:active": {
                            backgroundColor: "black",
                            color: "white",
                          },
                        }}
                      >
                        View Details
                      </Button>

                      {hasPermission4 && <Button
                        variant="contained"
                        onClick={() => handleOpen(row)}
                        sx={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid black",
                          textTransform: "none",
                          borderRadius: "8px",
                          width: "auto", // Or set a specific width
                          minWidth: "120px",
                          "&:hover": {
                            backgroundColor: "black",
                            color: "white",
                          },
                          "&:active": {
                            backgroundColor: "black",
                            color: "white",
                          },
                        }}
                      >
                        Credit/Debit
                      </Button>}
                    </TableCell>
                  }

                  {!FleetIdFromLocal && hasPermission2 && <TableCell align="center">
                    {row.deactivation_status !== 1 && <Button
                      variant="contained"
                      onClick={() => handleOpenDeactivateModal(row, 'activate')}
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        border: "1px solid black",
                        textTransform: "none",
                        borderRadius: "8px",
                        width: "auto", // Or set a specific width
                        minWidth: "120px",
                        marginBottom: "10px",
                        "&:hover": {
                          backgroundColor: "black",
                          color: "white",
                        },
                        "&:active": {
                          backgroundColor: "black",
                          color: "white",
                        },
                      }}
                    >
                      Activate
                    </Button> }

                    {!FleetIdFromLocal && row.deactivation_status !== 2 && <Button
                      variant="contained"
                      onClick={() => handleOpenDeactivateModal(row, 'deactivate')}
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        border: "1px solid black",
                        textTransform: "none",
                        borderRadius: "8px",
                        width: "auto", // Or set a specific width
                        minWidth: "120px",
                        marginBottom: "10px",
                        "&:hover": {
                          backgroundColor: "black",
                          color: "white",
                        },
                        "&:active": {
                          backgroundColor: "black",
                          color: "white",
                        },
                      }}
                    >
                      Deactivate
                    </Button> }

                    {!FleetIdFromLocal && <Button
                      variant="contained"
                      onClick={() => handleOpenDeactivateModal(row, 'delete')}
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        border: "1px solid black",
                        textTransform: "none",
                        borderRadius: "8px",
                        width: "auto", // Or set a specific width
                        minWidth: "120px",
                        "&:hover": {
                          backgroundColor: "black",
                          color: "white",
                        },
                        "&:active": {
                          backgroundColor: "black",
                          color: "white",
                        },
                      }}
                    >
                      Delete
                    </Button>}
                  </TableCell>}
                  
                  {Boolean(FleetIdFromLocal) && (
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        onClick={() => handleOpenRemoveFleetModal(row)}
                        sx={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid black",
                          textTransform: "none",
                          borderRadius: "8px",
                          width: "auto",
                          minWidth: "140px",
                          "&:hover": {
                            backgroundColor: "black",
                            color: "white",
                          },
                          "&:active": {
                            backgroundColor: "black",
                            color: "white",
                          },
                        }}
                      >
                        Remove from Fleet
                      </Button>
                    </TableCell>
                  )}
                  {admin_set_driver_online_status==1 && <TableCell>
                  <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "8px 12px",
                    borderRadius: "8px",
                    backgroundColor: (driverStatuses[row.driver_id] ?? row.driver_current_status === 1) ? "rgba(13, 186, 120, 0.1)" : "rgba(244, 67, 54, 0.1)",
                    border: `1px solid ${(driverStatuses[row.driver_id] ?? row.driver_current_status === 1) ? "#0DBA78" : "#F44336"}`,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "500",
                      color: (driverStatuses[row.driver_id] ?? row.driver_current_status === 1) ? "#0DBA78" : "#F44336",
                      fontSize: "14px",
                      minWidth: "60px",
                    }}
                  >
                    {(driverStatuses[row.driver_id] ?? row.driver_current_status === 1) ? 'Online' : 'Offline'}
                  </Typography>
                  <CustomSwitch
                    checked={(driverStatuses[row.driver_id] ?? row.driver_current_status === 1)}
                    backgroundtheme={(driverStatuses[row.driver_id] ?? row.driver_current_status === 1) ? "#0DBA78" : "#F44336"}
                    onChange={(e) => handleToggle(row.driver_id, e.target.checked)}
                  />
                </Box>
                  </TableCell>}

                </TableRow>
              ))}
            </TableBody>
          </Table>
          {filteredRows && (
            <div className="custom-pagination">
              <div className="pagination-info">
                {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                  (page + 1) * rowsPerPage,
                  filteredRows.length
                )} of ${filteredRows.length} entries`}
              </div>
              <div className="pagination-controls">
                <button
                  onClick={() => handleChangePage(null, page - 1)}
                  disabled={page === 0}
                  className="pagination-arrow"
                >
                  <img src={prevIcon} alt="Previous" />
                </button>
                <div className="pagination-numbers">
                  {/* {[...Array(Math.ceil(filteredRows.length / rowsPerPage))].map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${
                                        page === index ? 'active' : ''
                                    }`}
                                >
                                    {index + 1}
                                </button>
                            ))} */}
                  {page > 1 && (
                    <>
                      <button
                        onClick={() => handleChangePage(null, 0)}
                        className="pagination-number"
                      >
                        1
                      </button>
                      <span className="pagination-dots">...</span>
                    </>
                  )}
                  {[...Array(Math.ceil(filteredRows.length / rowsPerPage))]
                    .map((_, index) => index)
                    .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                    .map((index) => (
                      <button
                        key={index}
                        onClick={() => handleChangePage(null, index)}
                        className={`pagination-number ${
                          page === index ? "active" : ""
                        }`}
                      >
                        {index + 1}
                      </button>
                    ))}

                  {page < Math.ceil(filteredRows.length / rowsPerPage) - 2 && (
                    <>
                      <span className="pagination-dots">...</span>
                      <button
                        onClick={() =>
                          handleChangePage(
                            null,
                            Math.ceil(filteredRows.length / rowsPerPage) - 1
                          )
                        }
                        className="pagination-number"
                      >
                        {Math.ceil(filteredRows.length / rowsPerPage)}
                      </button>
                    </>
                  )}
                </div>
                <button
                  onClick={() => handleChangePage(null, page + 1)}
                  disabled={
                    page >= Math.ceil(filteredRows.length / rowsPerPage) - 1
                  }
                  className="pagination-arrow"
                >
                  <img src={nextIcon} alt="Next" />
                </button>
              </div>
            </div>
          )}
        </TableContainer>

        <Modal 
          open={openDocImage} 
          onClose={handleImageClose}
          aria-labelledby="image-modal-title"
          aria-describedby="image-modal-description"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              position: 'relative', 
              width: '90vw', 
              height: '90vh',
              maxWidth: '500px', 
              maxHeight: '500px', 
              borderRadius: '12px',
              overflow: 'hidden', 
              backgroundColor: 'white',
              display: 'flex',
              justifyContent: 'center', 
              alignItems: 'center',
              outline: 'none',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={currentImage}
              alt="Magnified Document"
              style={{maxWidth:'100%', maxHeight:'100%', objectFit:'contain'}}
            />
          </Box>
        </Modal>

        {openTmsDriver && (
          <div 
            style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                zIndex: 1000,overflowY: 'auto',padding: 20
            }}>
            <Box>
                <div style={{ position: 'relative', padding: '40px 0' }}>
                    <IconButton aria-label="close" onClick={handleCloseTmsDriverModal}
                        style={{
                            position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                        <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                    </IconButton>
                    <Paper elevation={3}
                        style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                            backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                        <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                            Add Driver
                        </Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <Label style={{color:'#1A1E25', fontSize:'16px'}}>Driver Name<span style={{ color: 'red' }}>*</span></Label>
                                <TextField sx={{marginTop:'1%'}} placeholder="Driver Name" fullWidth variant="outlined" type="text"
                                    value={tmsDriverName} 
                                    onChange={(e) => {
                                        setTmsDriverName(e.target.value);
                                        setTmsDriverErrors({...tmsDriverErrors, name: !e.target.value.trim()});
                                    }}
                                    error={tmsDriverErrors.name}
                                    helperText={tmsDriverErrors.name ? "Driver name is required" : ""}
                                    InputProps={{
                                        inputProps: { min: 0 }, // Prevent values less than zero
                                        style: {
                                            height: '52px',
                                            borderRadius:'12px',
                                            fontSize: '16px',
                                            padding: '8px 14px',
                                            backgroundColor: '#FFFFFF',
                                        },
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} sx={{borderRadius:'12px', border: tmsDriverErrors.document ? '1px solid #d32f2f' : '1px solid #D1D5DB', padding:'4px', marginTop:'16px', marginLeft:'8px'}}>
                                <Grid2 sx={{backgroundColor:'#F9F9F9', borderRadius:'8px', padding:'8px'}}>
                                    Driver Document<span style={{ color: 'red' }}>*</span>
                                </Grid2>
                                <Grid2 container size={12} sx={{marginTop:'12px'}}>
                                    <Grid2 size={3} sx={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                                        {tmsDriverDocImageUrl ? (
                                            <img src={tmsDriverDocImageUrl} alt="Driver Document" height="100px" width="100px" style={{objectFit:'cover', borderRadius:'6px', border:'1px solid #ddd'}} />
                                        ) : (
                                            <img src={defaultImg} alt="img" height="100px" width="100px" style={{objectFit:'cover', borderRadius:'6px', border: tmsDriverErrors.document ? '1px solid #d32f2f' : '1px solid #ddd'}} />
                                        )}
                                        
                                    </Grid2>
                                    <Grid2 size={9}>
                                        <Button
                                            variant="contained"
                                            component="label" fullWidth
                                            size="small"
                                            sx={{
                                                marginTop:'8px', 
                                                fontSize:'12px', 
                                                borderRadius:'6px', 
                                                border: tmsDriverErrors.document ? '1px solid #d32f2f' : '1px dotted #9CA2AA', 
                                                backgroundColor:'#F9F9F9', 
                                                marginBottom: tmsDriverErrors.document ? '2px' : '12px'
                                            }}
                                        >
                                            <Typography sx={{color:'#6B6F74', textTransform:'none', fontSize:'12px'}}>Click here to upload</Typography>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                hidden
                                                onChange={(e) => {
                                                    handleHealthCardImageChange(e);
                                                    setTmsDriverErrors({...tmsDriverErrors, document: false});
                                                }}
                                            />
                                        </Button>
                                        {tmsDriverErrors.document && 
                                            <Typography sx={{color: '#d32f2f', fontSize: '0.75rem', marginLeft: '14px', marginBottom: '12px'}}>
                                                Driver document is required
                                            </Typography>
                                        }
                                    </Grid2>
                                </Grid2>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                            <Label style={{color:'#1A1E25', fontSize:'16px'}}>Email<span style={{ color: 'red' }}>*</span></Label>
                            <TextField sx={{marginTop:'1%'}} placeholder="Email" fullWidth variant="outlined" type="email"
                                value={tmsDriverEmail} 
                                onChange={(e) => {
                                  handleEmailChange(e);
                                  setTmsDriverErrors({...tmsDriverErrors, email: !e.target.value.trim() || !validateEmail(e.target.value)});
                                }}
                                error={tmsDriverErrors.email || emailError}
                                helperText={tmsDriverErrors.email ? "Valid email address is required" : ""}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    style: {
                                        height: '52px',
                                        borderRadius:'12px',
                                        fontSize: '16px',
                                        padding: '8px 14px',
                                        backgroundColor: '#FFFFFF',
                                    },
                                }}
                            />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Label style={{color:'#1A1E25', fontSize:'16px'}}>Mobile Number<span style={{ color: 'red' }}>*</span></Label>
                                <div style={{width:'100%', marginTop:'1%', borderRadius:'12px', backgroundColor:'white'}}>
                                    <PhoneInput
                                        defaultCountry="IN"
                                        value={tmsDriverPhone}
                                        onChange={(value) => {
                                            setTmsDriverPhone(value);
                                            setTmsDriverErrors({...tmsDriverErrors, phone: !value.trim()});
                                            try {
                                                const parsed = parsePhoneNumber(value);
                                                if (parsed) {
                                                    setTmsDriverCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                }
                                            } catch (err) {
                                                console.error('Invalid phone number:', err);
                                                setTmsDriverCountryCode('');
                                            }
                                        }}
                                    placeholder="Enter phone number"
                                    style={{
                                        height: '44px',
                                        fontSize: '16px',
                                        alignItems: 'normal', marginTop:'2%',
                                        border: tmsDriverErrors.phone ? '1px solid #d32f2f' : 'none'
                                    }}
                                />
                                {tmsDriverErrors.phone && 
                                    <Typography sx={{color: '#d32f2f', fontSize: '0.75rem', marginTop: '3px', marginLeft: '14px'}}>
                                        Phone number is required
                                    </Typography>
                                }
                                </div>
                            </Grid>
                        </Grid>

                        <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'8%' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={saveNewTmsDriver}
                                sx={{width: '140px',height: '50px',textTransform: 'none',
                                    fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                Save
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleCloseTmsDriverModal}
                                sx={{
                                    width: '140px',
                                    height: '50px',
                                    textTransform: 'none',
                                    fontSize: '16px',
                                    backgroundColor: '#F0F0F0',
                                    color: '#B0B0B0',
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Paper>

                </div>
            </Box>
          </div>
        )}
<Dialog
    open={allDriversMapOpen}
    onClose={() => {
        setAllDriversMapOpen(false);
        setSelectedMarkerInfo(null);
    }}
    fullWidth
    maxWidth="lg"
    PaperProps={{
        sx: {
            height: '80vh',
            maxHeight: '800px',
        },
    }}
>
    <DialogTitle
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        }}
    >
        <Typography sx={{ fontWeight: 600, fontSize: '18px' }}>Live Locations</Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {/* Legend */}
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box sx={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: '#0DBA78' }} />
                    <Typography sx={{ fontSize: '13px', color: '#4E545D' }}>Online</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box sx={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: '#D14545' }} />
                    <Typography sx={{ fontSize: '13px', color: '#4E545D' }}>Offline</Typography>
                </Box>
            </Box>

            <IconButton
                onClick={() => {
                    setAllDriversMapOpen(false);
                    setSelectedMarkerInfo(null);
                }}
                size="small"
            >
                <CloseIcon />
            </IconButton>
        </Box>
    </DialogTitle>

    <DialogContent sx={{ p: 0, height: '100%' }}>
        {isMapsLoaded ? (
            <GoogleMap
                mapContainerStyle={{ width: '100%', height: '100%' }}
                center={allDriversMapCenter}
                zoom={12}
                onLoad={onAllDriversMapLoad}
            >
                {allDriversMapReady &&
                    filteredRows
                        .filter(row => {
                            const lat = parseFloat(row.current_latitude);
                            const lng = parseFloat(row.current_longitude);
                            return !isNaN(lat) && !isNaN(lng) && !(lat === 0 && lng === 0);
                        })
                        .map((row) => {
                            const lat = parseFloat(row.current_latitude);
                            const lng = parseFloat(row.current_longitude);
                            const isOnline = row.driver_current_status == 1;
                            return (
                                <Marker
                                    key={`marker-${row.driver_id}`}
                                    position={{ lat, lng }}
                                    title={`${row.driver_name} (ID: ${row.driver_id})`}
                                    icon={{
                                        url: isOnline
                                            ? mapPin
                                            : mapPinoffline,
                                    }}
                                    onClick={() => setSelectedMarkerInfo(row)}
                                />
                            );
                        })}
{allDriversMapReady && selectedMarkerInfo && (
    <InfoWindow
        key={`infowindow-${selectedMarkerInfo.driver_id}`}
        position={{
            lat: parseFloat(selectedMarkerInfo.current_latitude),
            lng: parseFloat(selectedMarkerInfo.current_longitude),
        }}
        onCloseClick={() => setSelectedMarkerInfo(null)}
    >
        <Box sx={{ minWidth: 220, padding: '4px', position: 'relative' }}>
            <IconButton
                size="small"
                onClick={() => setSelectedMarkerInfo(null)}
                sx={{ position: 'absolute', top: -4, right: -4, padding: '2px' }}
            >
                <CloseIcon sx={{ fontSize: 16 }} />
            </IconButton>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Avatar
                    sx={{ borderColor: '#0065FF', border: 1 }}
                    alt={selectedMarkerInfo.driver_name}
                    src={selectedMarkerInfo.driver_image}
                />
                <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>
                        {selectedMarkerInfo.driver_name}
                    </Typography>
                    <Typography sx={{ fontSize: '12px', color: '#83888E' }}>
                        ID: {selectedMarkerInfo.driver_id}
                    </Typography>
                </Box>
            </Box>
            <Typography sx={{ fontSize: '13px', marginTop: '8px' }}>
                Phone: {selectedMarkerInfo.phone_number}
            </Typography>
            <Typography sx={{ fontSize: '13px' }}>
                Status: {selectedMarkerInfo.driver_current_status == 1 ? 'Online' : 'Offline'}
            </Typography>
        </Box>
    </InfoWindow>
)}
            </GoogleMap>
        ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Typography>Loading map... isMapsLoaded: {String(isMapsLoaded)}</Typography>
            </Box>
        )}
    </DialogContent>
</Dialog>
      <Dialog
          open={singleDriverMapOpen}
          onClose={() => {
              setSingleDriverMapOpen(false);
              setSelectedMapDriver(null);
          }}
          fullWidth
          maxWidth="md"
      >
          <DialogTitle>
              {selectedMapDriver?.driver_name}
          </DialogTitle>

          <DialogContent>
      {isMapsLoaded && selectedMapDriver ? (
          <Box
          sx={{
              width: '100%',
              height: '400px',
              position: 'relative',
              zIndex: 1,
              overflow: 'hidden',
          }}
      >
              <GoogleMap
    mapContainerStyle={{
        width: '100%',
        height: '400px',
        position: 'relative',
    }}
    center={{
        lat: selectedMapDriver.mapLat,
        lng: selectedMapDriver.mapLng,
    }}
    zoom={15}
    onLoad={(map) => {
        window.google.maps.event.addListenerOnce(map, 'idle', () => {
            map.setCenter({
                lat: selectedMapDriver.mapLat,
                lng: selectedMapDriver.mapLng,
            });
            map.setZoom(15);
            setMapReady(true);
        });
    }}
>
    {mapReady && (
        <Marker
            position={{
                lat: selectedMapDriver.mapLat,
                lng: selectedMapDriver.mapLng,
            }}
            icon={{
                url: pickupMarker,
                scaledSize: new window.google.maps.Size(40, 40),
                anchor: new window.google.maps.Point(20, 40),
            }}
            zIndex={999999}
        />
    )}
</GoogleMap>
          </Box>
      ) : (
          <Box
              sx={{
                  height: '400px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
              }}
          >
              <Typography sx={{ color: '#83888E' }}>
                  No location data available for this driver.
              </Typography>
          </Box>
      )}
          </DialogContent>
      </Dialog>

        {openAddModal && (
          <div 
              style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                  zIndex: 1000,overflowY: 'auto',padding: 20
              }}>
              <Box>
                  <div style={{ position: 'relative', padding: '40px 0' }}>
                      <IconButton aria-label="close" onClick={handleCloseModal}
                          style={{
                              position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                          <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                      </IconButton>
                      <Paper elevation={3}
                          style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                              backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                          <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                              Add Driver
                          </Typography>
                          {FleetIdFromLocal && (
                            <Grid container spacing={1} sx={{ marginBottom: '16px' }}>
                              <Grid item xs={12} sm={7}>
                                <Label>Mobile Number<span style={{ color: 'red' }}>*</span></Label>
                                <PhoneInput
                                  defaultCountry="IN"
                                  value={newDriverPhone}
                                  onChange={(value) => {
                                    setNewDriverPhone(value || '');

                                    // number changed -> lock everything again and drop the old prefill
                                    setDriverFetched(false);
                                    setDriverByPhone(null);
                                    setNewDriverName('');
                                    setNewDriverEmail('');

                                    try {
                                      const parsed = value ? parsePhoneNumber(value) : null;
                                      setNewDriverCountryCode(parsed?.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                    } catch (err) {
                                      setNewDriverCountryCode('');
                                    }
                                  }}
                                  placeholder="Enter phone number"
                                  style={{ height: '48px', fontSize: '16px', alignItems: 'normal', marginTop: '2%' }}
                                />
                                {driverFormErrors.phone && (
                                  <Typography color="error" variant="caption" sx={{ ml: 1 }}>
                                    {driverFormErrors.phone}
                                  </Typography>
                                )}
                              </Grid>
                              <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Button
                                  onClick={searchDriverByPhone}
                                  sx={{
                                    textTransform: 'none', borderRadius: '8px', width: '100%',
                                    color: '#0065FF', height: '48px', border: '1px solid #0065FF'
                                  }}
                                >
                                  Fetch Details
                                </Button>
                              </Grid>
                            </Grid>
                          )}

                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={FleetIdFromLocal?6:12}>
                                <Label>Name<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%'}}
                                    placeholder="Name" fullWidth variant="outlined" type="text" 
                                    value={newDriverName}
                                    disabled={fleetFieldsLocked}
                                    onChange={(e) => setNewDriverName(e.target.value)}
                                    error={!!driverFormErrors.name}
                                    helperText={driverFormErrors.name}
                                    InputProps={{
                                        inputProps: { min: 0 }, // Prevent values less than zero
                                        style: {height: '48px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid>

                              {!FleetIdFromLocal && <Grid item xs={12} sm={6}>
                                <Label>Mobile Number<span style={{ color: 'red' }}>*</span></Label>
                                <PhoneInput
                                  defaultCountry="IN"
                                  value={newDriverPhone}
                                  onChange={(value) => {
                                    setNewDriverPhone(value);
                                    try {
                                      const parsed = parsePhoneNumber(value);
                                      if (parsed) {
                                        setNewDriverCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                      }
                                    } catch (err) {
                                      console.error('Invalid phone number:', err);
                                      setNewDriverCountryCode('');
                                    }
                                  }}
                                  placeholder="Enter phone number"
                                  style={{
                                    height: '48px',
                                    fontSize: '16px',
                                    alignItems: 'normal', marginTop:'2%',
                                    borderColor: driverFormErrors.phone ? 'red' : undefined
                                  }}
                                />
                                {driverFormErrors.phone && (
                                  <Typography color="error" variant="caption" sx={{ ml: 1 }}>
                                    {driverFormErrors.phone}
                                  </Typography>
                                )}
                            </Grid>}

                            <Grid item xs={12} sm={6}>
                                <Label>Email ID<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%'}}
                                    placeholder="Email" fullWidth variant="outlined" type="text" 
                                    value={newDriverEmail}
                                    disabled={fleetFieldsLocked}
                                    onChange={(e) => setNewDriverEmail(e.target.value)}
                                    error={!!driverFormErrors.email}
                                    helperText={driverFormErrors.email}
                                    InputProps={{
                                        inputProps: { min: 0 }, // Prevent values less than zero
                                        style: {height: '48px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                    }}
                                />
                            </Grid>

                            {is_rizzo_client==1 && 
                              <Grid item xs={12} sm={6} sx={{marginTop:'2%'}}>
                                <Label>Select Color<span style={{ color: 'red' }}>*</span></Label>
                                <Grid container spacing={1} alignItems="center" sx={{marginTop:'1px'}}>
                                    <Grid item>
                                        <input
                                        type="color"
                                        value={colorCode}
                                        disabled={fleetFieldsLocked}
                                        onChange={(e) => setColorCode(e.target.value)}
                                        style={{ border: 'none', background: 'none', width:'48px', height:'48px', cursor: 'pointer' }}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <TextField fullWidth variant="outlined" type="text" 
                                        // label="RGB Value"
                                        sx={{width:'100%'}}
                                        value={colorCode}
                                        disabled={fleetFieldsLocked}
                                        onChange={(e) => setColorCode(e.target.value)}
                                        InputProps={{
                                          inputProps: { min: 0 }, // Prevent values less than zero
                                          style: {height: '48px', width:'260px', fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                        }}
                                        />
                                    </Grid>
                                </Grid>
                              </Grid>
                            }

                            {(is_rizzo_client!=1) && 
                              <Grid item xs={12} sm={6}>
                                  <Label>Gender<span style={{ color: 'red' }}>*</span></Label>
                                  <Select sx={{marginTop:'2%'}}
                                    value={newDriverGender} fullWidth
                                    disabled={fleetFieldsLocked}
                                    onChange={(e) => setNewDriverGender( e.target.value)}
                                    style={{ height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                    <MenuItem value="">Gender</MenuItem>
                                    <MenuItem value="1">Male</MenuItem>
                                    <MenuItem value="2">Female</MenuItem>
                                    <MenuItem value="3">Others</MenuItem>
                                </Select>
                              </Grid>
                            }

                            {is_rizzo_client!=1 &&
                              <Grid item xs={12} sm={6}>
                                  <Label>Date of Birth<span style={{ color: 'red' }}>*</span></Label><br/>
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                      value={newDriverDob}
                                      disabled={fleetFieldsLocked}
                                      onChange={(value) => setNewDriverDob(value)}
                                      slotProps={{
                                        textField: {
                                          fullWidth: true,
                                          sx: {
                                            marginTop:'2%', 
                                            height: '48px', // Outer box height
                                            '& .MuiInputBase-root': {
                                              height: '48px', // Internal input height
                                              borderRadius:'8px',
                                            },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                              </Grid>
                            }

                            {driver_vehicle_attachment_enabled=="1" && (
                              <Grid item xs={12} sm={12}>
                                <Label>Select Vehicle<span style={{ color: 'red' }}>*</span></Label>
                                <Select
                                  value={newDriverVehicle}
                                  disabled={fleetFieldsLocked}
                                  onChange={(e) => setNewDriverVehicle( e.target.value)} 
                                  displayEmpty fullWidth
                                  style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF', marginTop:'1%'}}>
                                    <MenuItem value="">Select Vehicle</MenuItem>
                                    {availableVehicle.map((vehicle) => (
                                        <MenuItem key={vehicle.vehicle_id} value={vehicle.vehicle_id}>
                                            {vehicle.vehicle_number}
                                        </MenuItem>
                                    ))}
                                </Select>
                              </Grid>
                            )}
                          </Grid>

                          {!hideDocuments && (
                          <Paper elevation={3}
                            style={{
                              padding: '30px', maxWidth: '800px', margin: '0 auto',backgroundColor: '#FFFFFF',borderRadius: '12px', marginTop:'3%'
                            }}
                          >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                                Documents{activaDocs.some(doc => doc.is_required === 1) && <span style={{ color: 'red' }}>*</span>}
                              </Typography>
                            </div>
                            {documentErrors.some(err => err?.documentNumber || err?.image) && (
                              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                                Please complete all required document information
                              </Typography>
                            )}
                            <>
                            {activaDocs.map((doc, index) => (
                              <div key={index} style={{
                                marginBottom: '20px',
                                padding: '10px',
                                border: `1px solid ${(documentErrors[index]?.documentNumber || documentErrors[index]?.image || documentErrors[index]?.expiryDate) ? '#f44336' : '#ccc'}`,
                                borderRadius: '8px',
                                backgroundColor: '#F9F9F9',
                                maxWidth: '800px',
                                margin: '0 auto',
                                marginTop:'4%'
                              }}>
                            
                                <Grid2>
                                  <Typography>{doc.document_name}
                                  {doc.is_required==1 && (<span style={{ color: 'red' }}>*</span>)}</Typography>

                                  <Grid2 sx={{backgroundColor:'#fff', padding:'16px', borderRadius:'12px', marginTop:'2%'}}>
                                    <Grid item xs={12} sm={12}>
                                      <Label>Document No.
                                      {doc.is_required==1 && (<span style={{ color: 'red' }}>*</span>)}</Label>
                                      <TextField  sx={{marginTop:'2%'}}
                                          placeholder="Document Number" fullWidth variant="outlined" type="text" 
                                          disabled={fleetFieldsLocked}
                                          onChange={(e) => {
                                            const updatedDocs = [...newDriverDocuments];
                                            updatedDocs[index].document_number = e.target.value;
                                            setNewDriverDocuments(updatedDocs);
                                          }}
                                          error={!!documentErrors[index]?.documentNumber}
                                          helperText={documentErrors[index]?.documentNumber}
                                          InputProps={{
                                              inputProps: { min: 0 }, // Prevent values less than zero
                                              style: {height: '48px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                          }}
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={12} sx={{ marginTop: '3%' }}>
                                      <Label>Document Expiry Date: 
                                      {doc.is_doc_expired==1 && (<span style={{ color: 'red' }}>*</span>)}</Label>
                                      <Box sx={{ width: '100%', marginTop:'2%' }}>
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                          sx={{
                                            '& .MuiOutlinedInput-root': {
                                                height: '48px',
                                                borderRadius: '8px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                          }}
                                          disabled={fleetFieldsLocked}
                                          value={doc.expiry_date ? dayjs(doc.expiry_date) : null}
                                          onChange={(newValue) => {
                                            const updatedDocs = [...newDriverDocuments];
                                            updatedDocs[index].expiry_date = newValue ? newValue.format('YYYY-MM-DD') : '';
                                            setNewDriverDocuments(updatedDocs);
                                            
                                            // Clear error if date is selected
                                            if (newValue && documentErrors[index]?.expiryDate) {
                                              const newErrors = [...documentErrors];
                                              delete newErrors[index].expiryDate;
                                              setDocumentErrors(newErrors);
                                            }
                                          }}
                                          slotProps={{
                                            textField: {
                                              fullWidth: true,
                                              placeholder: 'Select expiry date'
                                            }
                                          }}
                                        />
                                      </LocalizationProvider>
                                      </Box>
                                    </Grid>

                                    <Grid2 sx={{marginTop:'3%'}}>

                                      <Label>Upload Image
                                      {doc.is_required==1 && (<span style={{ color: 'red' }}>*</span>)}</Label>
                                      {documentErrors[index]?.image && (
                                        <Typography color="error" variant="caption" sx={{ display: 'block', mt: 0.5 }}>
                                          {documentErrors[index].image}
                                        </Typography>
                                      )}

                                      {/* <Box sx={{ display: 'flex', gap: 2, marginTop:'2%' }}>
                                        {Array.from({ length: doc.no_of_images }).map((_, imgIndex) => (
                                          <React.Fragment key={imgIndex}>
                                            <input
                                              type="file"
                                              accept="image/*"
                                              style={{ display: 'none' }}
                                              onChange={handleFileChange(index, imgIndex)}
                                              id={`upload-${index}-${imgIndex}`}
                                            />
                                            <label htmlFor={`upload-${index}-${imgIndex}`}>
                                              <UploadButton startIcon={<UploadIcon sx={{ fontSize: 20 }} />} component="span">
                                                Upload {imgIndex + 1}
                                              </UploadButton>
                                            </label>
                                          </React.Fragment>
                                        ))}

                                      </Box> */}
                                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, marginTop: '2%' }}>
                                        {Array.from({ length: doc.no_of_images }).map((_, imgIndex) => (
                                          <React.Fragment key={imgIndex}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                              <input
                                                type="file"
                                                accept="image/*"
                                                disabled={fleetFieldsLocked}
                                                style={{ display: 'none' }}
                                                onChange={handleFileChange(index, imgIndex)}
                                                id={`upload-${index}-${imgIndex}`}
                                              />
                                              <label htmlFor={`upload-${index}-${imgIndex}`}>
                                                <UploadButton
                                                  disabled={fleetFieldsLocked}
                                                  startIcon={<UploadIcon sx={{ fontSize: 20 }} />}
                                                  component="span"
                                                >
                                                  Upload {imgIndex + 1}
                                                </UploadButton>
                                              </label>

                                              {newDriverDocuments[index]?.images?.[imgIndex] && (
                                                <img
                                                  src={newDriverDocuments[index].images[imgIndex]}
                                                  alt={`Uploaded ${imgIndex + 1}`}
                                                  style={{
                                                    marginTop: '8px',
                                                    height: '80px',
                                                    width: '80px',
                                                    objectFit: 'cover',
                                                    borderRadius: '6px',
                                                    border: '1px solid #ccc',
                                                  }}
                                                />
                                              )}
                                            </Box>
                                          </React.Fragment>
                                        ))}
                                      </Box>

                                    </Grid2>

                                  </Grid2>
                                </Grid2>
                                <Typography sx={{color:'#d32f2f',fontSize:'12px'}}>
                                  {documentErrors[index]?.expiryDate}
                                </Typography>
                    
                              </div>
                            ))}
                            </>

                          </Paper>
                          )}

                          <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'4%' }}>
                              <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={saveNewDriver}
                                  disabled={Boolean(FleetIdFromLocal) && !driverFetched}
                                  sx={{width: '140px',height: '50px',textTransform: 'none',
                                      fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                  Save
                              </Button>
                              <Button
                                  variant="contained"
                                  onClick={handleCloseModal}
                                  sx={{
                                      width: '140px',
                                      height: '50px',
                                      textTransform: 'none',
                                      fontSize: '16px',
                                      backgroundColor: '#F0F0F0',
                                      color: '#B0B0B0',
                                  }}
                              >
                                  Cancel
                              </Button>
                          </div>
                      </Paper>

                  </div>
              </Box>
          </div>
        )}

        {/* Dialog */}
        <Dialog
                open={open}
                onClose={handleClose}
                sx={{
                    '& .MuiDialog-paper': {
                        width: '50%',
                        maxWidth: 'none',
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                    }}
                >
                    User Wallet Transactions
                </DialogTitle>
                <DialogContent>
                    <Box display="flex" alignItems="center" mb={2}>
                        <Box width="30%" fontWeight="bold">
                            Type:
                        </Box>
                        <FormControl fullWidth>
                            <Select
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Type' }}
                            >
                                <MenuItem value="credit">Credit</MenuItem>
                                <MenuItem value="debit">Debit</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <Box display="flex" alignItems="center" mb={2}>
                        <Box width="30%" fontWeight="bold">
                            Amount:
                        </Box>
                        <TextField
                            fullWidth
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter Amount"
                        />
                    </Box>

                    <Box display="flex" alignItems="center" mb={2}>
                        <Box width="30%" fontWeight="bold">
                            Reason:
                        </Box>
                        <TextField
                            fullWidth
                            type="string"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="Enter Reason"
                        />
                    </Box>
                </DialogContent>

                <Box display="flex" justifyContent="center" gap={2} mt={3} mb={2}>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        sx={{ width: '150px' }}
                        disabled={!amount || !reason || txnLoading} // Disable if amount or reason is empty
                    >
                        {txnLoading ? 'Processing...' : (type === 'credit' ? 'Credit' : 'Debit')}
                    </Button>
                    <Button onClick={handleClose} color="secondary" variant="outlined">
                        Cancel
                    </Button>
                </Box>
            </Dialog>
        <Dialog
            open={findOtpModal}
            onClose={() => setFindOtpModal(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 3,
                    py: 2,
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: 2,
                            display: "grid",
                            placeItems: "center",
                            bgcolor: "#000000",
                            color: "#fff",
                        }}
                    >
                        <VisibilityIcon fontSize="small" />
                    </Box>
                    <Box>
                        <Typography sx={{ fontSize: 18, fontWeight: 700, lineHeight: 1.2 }}>
                            Find Driver OTP
                        </Typography>
                        <Typography sx={{ fontSize: 12, color: "#83888E" }}>
                            Search by driver ID or phone number
                        </Typography>
                    </Box>
                </Box>

                <IconButton
                    onClick={() => setFindOtpModal(false)}
                    size="small"
                    sx={{ color: "#83888E" }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>

            <Box sx={{ borderTop: "1px solid #EEF0F2" }} />

            <DialogContent sx={{ px: 3, py: 3 }}>
                <Stack spacing={2.5}>
                    <TextField
                        label="Driver ID"
                        placeholder="e.g. 10245"
                        fullWidth
                        value={searchDriverId}
                        onChange={(e) => {
                            setSearchDriverId(e.target.value);
                            setSearchPhone("");
                        }}
                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                    />

                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Box sx={{ flex: 1, height: "1px", bgcolor: "#EEF0F2" }} />
                        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#83888E" }}>
                            OR
                        </Typography>
                        <Box sx={{ flex: 1, height: "1px", bgcolor: "#EEF0F2" }} />
                    </Box>

                    <TextField
                        label="Phone Number"
                        placeholder="e.g. +91 98765 43210"
                        fullWidth
                        value={searchPhone}
                        onChange={(e) => {
                            setSearchPhone(e.target.value);
                            setSearchDriverId("");
                        }}
                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                    />

                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleOtpSearch}
                        disableElevation
                        sx={{
                            borderRadius: 2,
                            py: 1.25,
                            textTransform: "none",
                            fontWeight: 600,
                            backgroundColor: "#000000",
                            "&:hover": { backgroundColor: "#1a1a1a" },
                        }}
                    >
                        Find OTP
                    </Button>
                    {selectedDriver ? (
                        // One driver → show OTP
                        <Paper variant="outlined" sx={{ p: 0, borderRadius: 2.5, overflow: "hidden", borderColor: "#EEF0F2" }}>
                            {matchedDrivers.length > 1 && (
                                <Box
                                    onClick={() => setSelectedDriver(null)}
                                    sx={{ px: 2.5, py: 1.25, cursor: "pointer", color: "#0065FF", fontSize: 13, fontWeight: 600, borderBottom: "1px solid #EEF0F2", "&:hover": { bgcolor: "#F7F9FC" } }}
                                >
                                    ← Back to results
                                </Box>
                            )}
                            <Stack spacing={1.5} sx={{ p: 2.5 }}>
                                <Box>
                                    <Typography sx={{ fontSize: 12, color: "#83888E" }}>Driver Name</Typography>
                                    <Typography sx={{ fontWeight: 600 }}>{selectedDriver.driver_name || "—"}</Typography>
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: 12, color: "#83888E" }}>Driver ID</Typography>
                                    <Typography sx={{ fontWeight: 600 }}>{selectedDriver.driver_id}</Typography>
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: 12, color: "#83888E" }}>Phone</Typography>
                                    <Typography sx={{ fontWeight: 600 }}>{selectedDriver.phone_number || "—"}</Typography>
                                </Box>
                            </Stack>
                            <Box sx={{ bgcolor: "#E7F8F2", borderTop: "1px dashed #9BE3C9", py: 2.5, textAlign: "center" }}>
                                <Typography sx={{ fontSize: 11, fontWeight: 600, letterSpacing: 1.5, color: "#0DBA78", textTransform: "uppercase" }}>
                                    Login OTP
                                </Typography>
                                <Typography sx={{ fontSize: 40, fontWeight: 800, letterSpacing: 8, color: "#0B8A5A", fontVariantNumeric: "tabular-nums", lineHeight: 1.2 }}>
                                    {selectedDriver.login_otp || "----"}
                                </Typography>
                            </Box>
                        </Paper>
                    ) : matchedDrivers.length > 0 ? (
                        // Multiple matches → list them all
                        <Box>
                            <Typography sx={{ fontSize: 13, color: "#83888E", mb: 1 }}>
                                {matchedDrivers.length} matching {matchedDrivers.length === 1 ? "driver" : "drivers"}. Tap one to view its OTP.
                            </Typography>
                            <Stack spacing={1} sx={{ maxHeight: 280, overflowY: "auto" }}>
                                {matchedDrivers.map((driver) => (
                                    <Paper
                                        key={driver.driver_id}
                                        variant="outlined"
                                        onClick={() => setSelectedDriver(driver)}
                                        sx={{ p: 1.5, borderRadius: 2, borderColor: "#EEF0F2", display: "flex", alignItems: "center", gap: 1.5, cursor: "pointer", transition: "all 0.15s", "&:hover": { borderColor: "#000000", bgcolor: "#F7F9FC" } }}
                                    >
                                        <Avatar alt={driver.driver_name} src={driver.driver_image} sx={{ width: 40, height: 40 }} />
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                            <Typography sx={{ fontWeight: 600 }} noWrap>{driver.driver_name || "—"}</Typography>
                                            <Typography sx={{ fontSize: 12, color: "#83888E" }} noWrap>
                                                ID: {driver.driver_id} · {driver.phone_number || "—"}
                                            </Typography>
                                        </Box>
                                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#0065FF", whiteSpace: "nowrap" }}>
                                            View OTP →
                                        </Typography>
                                    </Paper>
                                ))}
                            </Stack>
                        </Box>
                    ) : (
                        // Nothing matches
                        (searchDriverId || searchPhone) && (
                            <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: "#F3C2C2", bgcolor: "#FCEDED", textAlign: "center" }}>
                                <Typography sx={{ color: "#D14545", fontWeight: 600 }}>No driver found</Typography>
                                <Typography sx={{ fontSize: 13, color: "#83888E" }}>Check the ID or phone number and try again.</Typography>
                            </Paper>
                        )
                    )}
                </Stack>
            </DialogContent>
        </Dialog>

            <Snackbar
                open={snackbar}
                autoHideDuration={2000}
                onClose={handleSnackbarClose}
                message={message}
                action={
          <React.Fragment>
            {showTemplateButton && (
              <CSVLink
                data={generateTemplateData()}
                headers={templateHeaders}
                filename="driver_import_template.csv"
                style={{ color: 'white', marginRight: '10px', textDecoration: 'underline' }}
              >
                Template
              </CSVLink>
            )}
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleSnackbarClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
      
      {/* Hidden file input for CSV import */}
      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />

          <Dialog
            open={openDeactivateModal}
            onClose={handleCloseDeactivateModal}
            PaperProps={{
              style: {
                borderRadius: '12px',
                padding: '8px',
                maxWidth: '500px'
              }
            }}
          >
            <DialogTitle>
              <Typography variant="h6" fontWeight="600">
                {actionType === 'activate' ? 'Activate' : 
                  actionType === 'deactivate' ? 'Deactivate' : 'Delete'} Driver
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleCloseDeactivateModal}
                sx={{
                  position: 'absolute',
                  right: 12,
                  top: 12,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Typography variant="body1" sx={{ my: 2 }}>
                Are you sure you want to {actionType === 'activate' ? 'activate' : 
                  actionType === 'deactivate' ? 'deactivate' : 'delete'} this driver?
              </Typography>
              
              <TextField
                autoFocus
                margin="dense"
                id="reason"
                label="Reason"
                type="text"
                fullWidth
                variant="outlined"
                value={deactivateReason}
                onChange={handleReasonChange}
                error={reasonError}
                helperText={reasonError ? "Reason is required" : ""}
                sx={{ mt: 2, mb: 3 }}
              />
              
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                  onClick={handleCloseDeactivateModal} 
                  sx={{ mr: 2, textTransform: 'none' }}
                >
                  Cancel
                </Button>
                <Button sx={{textTransform: 'none'}}
                  onClick={handleConfirmDeactivate} 
                  variant="contained" 
                  color={actionType === 'delete' ? 'error' : 
                        actionType === 'deactivate' ? 'warning' : 'primary'}
                >
                  {actionType === 'activate' ? 'Activate' : 
                    actionType === 'deactivate' ? 'Deactivate' : 'Delete'}
                </Button>
              </Box>
            </DialogContent>
          </Dialog>

          <Dialog
            open={openRemoveFleetModal}
            onClose={handleCloseRemoveFleetModal}
            PaperProps={{
              style: {
                borderRadius: '12px',
                padding: '8px',
                maxWidth: '500px'
              }
            }}
          >
            <DialogTitle>
              <Typography variant="h6" fontWeight="600">
                Remove from Fleet
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleCloseRemoveFleetModal}
                sx={{
                  position: 'absolute',
                  right: 12,
                  top: 12,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Typography variant="body1" sx={{ my: 2 }}>
                Would you like to remove the driver from this fleet?
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button
                  onClick={handleCloseRemoveFleetModal} 
                  sx={{ mr: 2, textTransform: 'none' }}
                >
                  No
                </Button>
                <Button sx={{textTransform: 'none'}}
                  onClick={handleConfirmRemoveFleet} 
                  variant="contained" 
                  color="error"
                >
                  Yes
                </Button>
              </Box>
            </DialogContent>
          </Dialog>
      </div>
    );
};

export default Dashboard;